// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT: ``,
    ACCOUNT_PROFILE: `계정 프로필`,
    ACCOUNT_CREATED: ``,
    ACCOUNT_VERIFIED: ``,
    LOG_IN_TO_START_ORDERING: ``,
    VERIFY_LINK_INVALID: ``,
    VERIFY_LINK_INVALID_LOG_IN: ``,
    ORDERS: ``,
    ORDER_NOT_FOUND: ``,
    ORDER_STATUS_COLLAPSE: ``,
    ORDER_STATUS_COMPLETE_ORDER: ``,
    ORDER_STATUS_DETAILS: ``,
    ORDER_STATUS_DIRECTIONS: ``,
    ORDER_STATUS_ERROR: ``,
    ORDER_STATUS_ITEM_COUNT: ``,
    ORDER_STATUS_ONE_ITEM: ``,
    ORDER_STATUS_ORDER: ``,
    ORDER_STATUS_PICKUP: ``,
    ORDER_STATUS_PREPARING: ``,
    ORDER_STATUS_READY: ``,
    ORDER_STATUS_RECEIVED: ``,
    ORDER_STATUS_STORE_PICKUP: ``,
    ORDER_STATUS_TODAY_ASAP: ``,
    PROFILE: ``,
    PROFILE_UPDATED: ``,
    PAYMENT_METHODS: ``,
    PERSONAL_DETAILS: ``,
    SAVE_CHANGES: ``,
    ADD_CARD: ``,
    CARD_NICKNAME: ``,
    NO_SAVED_CARDS: ``,
    QR_CODE: ``,
    REFRESH_QR_CODE: ``,
    QR_CODE_SCAN_TO_PAY: ``,
    ADA_TOGGLE_ON: `탭하여 화면 높이 축소 활성화`,
    ADA_TOGGLE_OFF: `탭하여 화면 높이 축소 비활성화`,
    ADD: `추가`,
    ADD_DONATION: `기부 추가`,
    ADD_FUNDS: `자금 추가`,
    ADD_TIP: `팁 추가`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `주문에 추가`,
    ADD_NEW: `새로 추가`,
    ADDED: `추가됨`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `주문에 추가됨`,
    ADDON_TEXTFIELD_PLACEHOLDER: `선택 사항을 입력하세요.`,
    ADDRESS_CITY: `도시`,
    ADDRESS_LINE_1: `주소`,
    ADDRESS_LINE_2: `아파트, 층, 스위트, 건물, 회사 (선택 사항)`,
    ADDRESS_POSTAL_CODE: `우편번호`,
    ALCOHOL_VERIFICATION: `알코올 확인`,
    ALREADY_HAVE_AN_ACCOUNT: ``,
    ALSO_CONSIDER: `이런 건 어떠세요...`,
    APPLIED_STORED_VALUE_CARDS: `상품권`,
    ASAP: `가능한 빨리`,
    AT_LEAST_X: `최소 {{$1: number}}`,
    BACK: `뒤로`,
    BACK_TO_MENU: `메뉴로 돌아가기`,
    BACK_TO_MENU_FROM_LOYALTY: `메뉴로 돌아가기`,
    BACK_TO_CART: `장바구니로 돌아가기`,
    BACK_TO_PAYMENT_OPTIONS: `결제 방법으로 돌아가기`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `결제 방법으로 돌아가기`,
    BAD_ACCESS_CODE: `잘못된 접근 코드`,
    BALANCE: `잔액`,
    BAG_OPT_IN_PROMPT: `주문에 테이크아웃 가방을 추가하시겠습니까?`,
    BAG_OPT_IN_TITLE: `가방을 추가하시겠습니까?`,
    BAG_OPT_IN: `네, 가방이 필요합니다`,
    BAG_OPT_OUT: `아니요, 괜찮습니다`,
    BLOCKED_WORD_WARNING: `차단된 단어를 삭제해 주세요`,
    CALORIES: `칼로리`,
    CANCEL: `취소`,
    CANCEL_CHECKOUT: `취소`,
    CASH: `계산원`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `등록된 카드`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `비접촉식`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `수동 입력`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `외부 제공`,
    CARD_ENTRY_SCAN: `스캔`,
    CARD_ENTRY_SWIPE: `스와이프`,
    CARD_ENTRY_UNKNOWN: `알 수 없음`,
    CARD_EXPIRED: `카드 만료됨`,
    CARD_EXPIRING: `카드가 곧 만료됩니다`,
    CARD_ENDING_IN: ``,
    CARD_EXPIRES_ON: ``,
    CARD_EXPIRES_THIS_MONTH: ``,
    CARD_EXPIRED_LABEL: ``,
    REMOVE_SAVED_CARD_DESCRIPTION: ``,
    CARD_RENAMED: ``,
    REMOVE_SAVED_CARD: ``,
    REMOVE_SAVED_CARD_TITLE: ``,
    RENAME_CARD: ``,
    SHOW_QR_CODE: ``,
    CART: `장바구니`,
    CART_LABEL: `{{$1: number}}개 상품 {{$2: price}} 장바구니로 이동`,
    CART_TITLE: ``,
    CHANGE_ITEM: `상품 변경`,
    CHANGE_PASSWORD: `비밀번호 변경`,
    CHANGE_PASSWORD_SUCCESS: `비밀번호가 업데이트되었습니다.`,
    CHARS_LEFT: `{{$1: number}}자 남음`,
    CHECK_AMOUNT: `금액 확인 중...`,
    CHECKOUT: `결제`,
    CHECKOUT_STEP_CART: `장바구니`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `결제`,
    CHECKOUT_STEP_PAYING: `결제 중`,
    CHECKOUT_STEP_DONE: `완료`,
    CHECKOUT_WITH_FORCED_MENU: `매뉴 미리보기를 보고 있는 동안에는 체크 아웃을 할 수 없습니다.  "현재 보이는" 매뉴를 보고 있는 동안에만 체크 아웃이 가능합니다.`,
    CHECK_YOUR_EMAIL: ``,
    CHOOSE_OPTION: `옵션 선택`,
    CHOOSE_TIME_SLOT: `시간대를 선택해 주세요:`,
    CLEAR_ALL: `모두 지우기`,
    CLEARING_SESSION: `다음 고객을 위해 키오스크를 준비 중...`,
    CLOSE: `닫기`,
    CLOSED_SCREEN_MESSAGE: `죄송합니다. 현재 영업 중이 아니거나 모바일 주문을 받지 않습니다.`,
    CONFIRM: `확인`,
    CONFIRM_ADDRESS: `주소 확인`,
    CONFIRM_DISCARD: `이 상품을 삭제하시겠습니까?`,
    CONFIRM_DISCARD_CHANGES: `변경 사항을 취소하시겠습니까?`,
    CONFIRM_YOUR_ITEM: `상품을 확인해 주세요`,
    CONFIRM_QUIT: `종료하시겠습니까?`,
    CONFIRM_REFUND_AMOUNT: `이 거래에서 {{$1: dollar amount}}를 환불하시겠습니까?`,
    CONFIRMING_YOUR_CARD: `카드 확인 중...`,
    CONTINUE: `계속`,
    CONTINUE_AS_GUEST: `게스트로 계속`,
    COULD_WE_INTEREST: `이런 건 어떠세요...`,
    COMP_CARD: `컴프 카드`,
    COMP_CARD_SCAN: `컴프 카드 스캔`,
    COMP_CARD_SCAN_FAILED_TITLE: `컴프 카드 스캔 실패`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `컴프 카드 스캔 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    COMP_CARD_APPLYING_TITLE: `컴프 카드 적용 중`,
    COMP_CARD_APPLYING_ERROR_TITLE: `컴프 카드 적용 오류`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `컴프 카드 적용 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `컴프 카드 번호를 입력해 주세요`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `유효한 컴프 카드 번호를 입력해 주세요`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `유효한 컴프 카드 번호를 입력해 주세요`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `컴프 카드 PIN을 입력해 주세요`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `유효한 컴프 카드 PIN을 입력해 주세요`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `유효한 컴프 카드 PIN을 입력해 주세요`,
    COMP_CARD_ENTERING_NUMBER_HINT: `컴프 카드 번호를 입력해 주세요. 번호는 {{$1: number}}자리입니다.`,
    COMP_CARD_ENTERING_PIN_HINT: `컴프 카드 PIN을 입력해 주세요. 번호는 {{$1: length}}자리입니다.`,
    COMP_CARD_ERROR_REMOVING: `컴프 카드 삭제 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    'bottom-bar.storm-toggle.on': `탭하여 Storm 탐색 활성화`,
    'bottom-bar.storm-toggle.off': `탭하여 Storm 탐색 비활성화`,
    'campus-card.label': `캠퍼스 카드`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `탭하여 캠퍼스 카드로 결제`,
    'campus-card.scan': `캠퍼스 카드 스캔`,
    'campus-card.scan-failed.title': `캠퍼스 카드 스캔 실패`,
    'campus-card.scan-failed.message': `캠퍼스 카드 스캔 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    'campus-card.enter-number': `캠퍼스 카드 번호 입력`,
    'campus-card.enter-pin': `캠퍼스 카드 PIN 입력`,
    'campus-card.applying.title': `캠퍼스 카드 적용 중`,
    'campus-card.applying.error.title': `캠퍼스 카드 적용 오류`,
    'campus-card.applying.error.message': `캠퍼스 카드 적용 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    'campus-card.entering-number.error.required': `캠퍼스 카드 번호를 입력해 주세요`,
    'campus-card.entering-number.error.invalid': `유효한 캠퍼스 카드 번호를 입력해 주세요`,
    'campus-card.entering-number.error.length': `유효한 캠퍼스 카드 번호를 입력해 주세요`,
    'campus-card.entering-number.hint': `캠퍼스 카드 번호를 입력해 주세요. 번호는 {{$1: number}}자리입니다.`,
    'campus-card.entering-pin.error.required': `캠퍼스 카드 PIN을 입력해 주세요`,
    'campus-card.entering-pin.error.invalid': `유효한 캠퍼스 카드 PIN을 입력해 주세요`,
    'campus-card.entering-pin.error.length': `유효한 캠퍼스 카드 PIN을 입력해 주세요`,
    'campus-card.entering-pin.hint': `캠퍼스 카드 PIN을 입력해 주세요. 번호는 {{$1: length}}자리입니다.`,
    'campus-card.error-removing': `캠퍼스 카드 삭제 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    'campus-card.no-balance.title': `사용 가능한 잔액 없음`,
    'campus-card.no-balance.message': `이 캠퍼스 카드에 사용 가능한 잔액이 없습니다.`,
    'campus-card.add-another': `다른 카드 추가`,
    'campus-card.remove': `캠퍼스 카드 삭제`,
    'campus-card.select-account.title': `계정 선택`,
    'campus-card.select-account.loading': `계정 불러오는 중...`,
    'campus-card.select-account.error.title': `계정을 불러올 수 없음`,
    'campus-card.select-account.error.message': `계정을 불러올 수 없습니다. 다시 시도해 주세요.`,
    'campus-card.select-account.column.account': `계정`,
    'campus-card.select-account.column.balance': `현재 잔액`,
    'campus-card.select-account.error.toast-title': `오류`,
    'campus-card.select-account.error.toast-message': `확인에 실패했습니다. 다시 시도해 주세요.`,
    'campus-card.swipe': `캠퍼스 카드를 스와이프하여 결제`,
    COUPON: `쿠폰`,
    COUPON_ALREADY_USED: `쿠폰 코드가 이미 사용되었습니다.`,
    COUPON_MIN_SPEND_NOT_MET: `입력한 쿠폰 코드가 최소 구매 금액을 충족하지 않습니다.`,
    COUPON_NOT_FOUND: `쿠폰 코드를 찾을 수 없습니다.`,
    COUPON_NOT_ACCEPTED: `입력한 쿠폰 코드가 승인되지 않았습니다.`,
    COUPON_APPLYING: `쿠폰 적용 중`,
    COUPON_APPLYING_ERROR_TITLE: `쿠폰 적용 오류`,
    COUPON_APPLYING_ERROR_MESSAGE: `쿠폰 적용 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `입력한 쿠폰 코드가 주문 요건을 충족하지 않습니다.`,
    COUPON_SCANNING_ERROR_TITLE: `쿠폰 스캔 오류`,
    COUPON_SCANNING_ERROR_MESSAGE: `쿠폰 스캔 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    COUPON_ENTERING_ERROR_LENGTH: `쿠폰 코드를 입력해 주세요.`,
    COUPON_ENTERING_ERROR_INVALID: `유효한 쿠폰 코드를 입력해 주세요.`,
    COUPON_ERROR_REMOVING: `쿠폰 삭제 중 오류가 발생했습니다. 다시 시도해 주세요. 문제가 지속되면 직원에게 문의해 주세요.`,
    CREATE_A_NEW_ACCOUNT: `새 계정 만들기`,
    CREATE_ACCOUNT: `계정 만들기`,
    CREATE_ACCOUNT_TERMS_LINE: `계정을 만들면 다음에 동의하는 것입니다:`,
    CREDIT_CARD: `신용카드`,
    CREDIT_CARD_NUMBER: `카드 번호`,
    CURBSIDE: `차량 픽업`,
    CURRENT_PASSWORD: `현재 비밀번호`,
    CUSTOM_TIP: `직접 입력`,
    CUSTOM_TIP_INVALID: `유효한 팁 금액을 입력해 주세요.`,
    CUSTOM_TIP_HINT: `팁 금액을 입력하세요. 최대: {{$1: number}}`,
    CUSTOM_DONATION: `직접 입력 기부`,
    CUSTOMER_CARDS: `저장된 카드 사용`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `로그인`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `내 계정`,
    CUSTOMIZE: `커스터마이즈`,
    DEBIT: `직불`,
    DEBIT_CREDIT_CARD: `직불/신용카드`,
    DEMO_PAY: `데모: 결제`,
    DELIVERY: `배달`,
    DELIVERY_ADDRESS: `배달 주소`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `{{$1: mod name}} 제거`,
    DINE_IN: `매장 식사`,
    DISCLAIMER_EMAIL: `이메일 주소 사용은 서비스 약관을 따릅니다.`,
    DISCLAIMER_PHONE: `전화번호 사용은 서비스 약관을 따릅니다.`,
    DISCLAIMER_PHONE_LINK: `서비스 약관:`,
    DISCLAIMER_PHONE_DESCRIPTION: `전화번호 사용에 관하여`,
    DISCLAIMER_NAME: `성함은 주문 확인 및 지정 구역에서의 픽업을 위해 사용됩니다.`,
    DISCOUNTS: `할인`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `할인은 결제 시 적용됩니다`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `할인은 결제 시 적용됩니다`,
    DONATION: `기부`,
    DONATION_APPLYING: `기부 처리 중...`,
    DONATION_APPLY_ERROR_TITLE: `기부 적용 오류`,
    DONATION_APPLY_ERROR_MESSAGE: `기부 처리 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    DONATION_FAILED: `기부에 실패했습니다. 다시 시도해 주세요.`,
    DONATION_ROUND_UP_TITLE: `합계를 올림하시겠습니까?`,
    DONATION_ROUND_UP_TO: `{{$1: amount}}으로 올림`,
    DONATION_ROUND_UP_SUBTITLE: `합계를 가장 가까운 달러로 올림하시겠습니까?`,
    DONATION_ROUND_UP_ACCEPT: `네, 올림합니다`,
    DONATION_ROUND_UP_REJECT: `아니요, 괜찮습니다`,
    DONATION_REMOVE: `기부 삭제`,
    DONE: `완료`,
    DONT_INCLUDE_UTENSILS: `수저 불필요`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `EBT 환불`,
    EBT_CHOICE_DIALOG_TITLE: `어떤 EBT 방법을 사용하시겠습니까?`,
    EBT_CHOICE_CASH_BENEFIT: `현금 혜택`,
    EBT_CHOICE_FOOD_STAMPS: `푸드 스탬프`,
    EBT_CARD_SUBTITLE: `신용카드 단말기에서 EBT 카드를 스와이프하세요`,
    EDIT: `편집`,
    EDIT_ORDER: `주문 편집`,
    EDIT_TIP: `팁 편집`,
    SAVE_ORDER: `주문 저장`,
    SAVE_BUTTON: ``,
    EMAIL_ADDRESS: `이메일 주소`,
    EMAIL_RECEIPT: `이메일 영수증`,
    EMAIL_REQUIRED_FOR_RECEIPT: `영수증에는 이메일이 필요합니다.`,
    EMAIL_RECEIPT_SEND_FAILED: `영수증을 보낼 수 없습니다. 다시 시도해 주세요.`,
    EMAIL_RECEIPT_SEND_SUCCESS: `영수증이 성공적으로 전송되었습니다.`,
    ENTER_ACCESS_CODE: `접근 코드를 입력하세요:`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `이메일 입력`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `스캔할 수 없나요? 카드 번호를 입력하세요.`,
    ENTER_PHONE_CONSENT: `SMS로 마케팅 자료 수신에 동의합니다.`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `전화번호 입력`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `안녕하세요 {{$1 guest name}}, 전화번호를 입력해 주세요`,
    ENTER_PHONE_LOYALTY: `휴대폰 번호 입력`,
    ENTER_PHONE_RECEIPT: `영수증 수신을 위해 휴대폰 번호를 입력하세요`,
    ENTER_PHONE_TEXT_WHEN_READY: `주문이 준비되면 문자로 알려드립니다. 전화번호를 입력하세요!`,
    ENTER_VEHICLE_DESCRIPTION: `차량 정보를 입력해 주세요. 주문을 가져다드리겠습니다:`,
    ENTER_YOUR_COUPON_CODE: `쿠폰 코드 입력`,
    ENTER_YOUR_COMP_CARD_NUMBER: `컴프 카드 번호 입력`,
    ENTER_YOUR_COMP_CARD_PIN: `컴프 카드 PIN 입력`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `상품권 번호 입력`,
    ENTER_YOUR_GIFT_CARD_PIN: `상품권 PIN 입력`,
    ENTER_YOUR_EMAIL: `이메일을 입력하세요:`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `유효하지 않은 이메일입니다. 다시 시도해 주세요.`,
    ENTER_YOUR_FIRST_NAME: `이름을 입력하세요:`,
    ENTER_YOUR_LAST_NAME: `성의 이니셜을 입력하세요:`,
    ENTER_YOUR_NAME: `성함을 입력하세요:`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `유효하지 않은 이름입니다. 다시 시도해 주세요.`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `이름을 입력해 주세요.`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `한 글자만 허용됩니다. 다시 시도해 주세요.`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `이름에는 글자만 사용할 수 있습니다. 다시 시도해 주세요.`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `이름에 부적절한 단어가 포함되어 있습니다. 다시 시도해 주세요.`,
    ERROR: `이런!`,
    ERROR_ADDING_ITEM: `장바구니에 상품을 추가하는 중 오류가 발생했습니다. 다시 시도해 주세요. 문제가 지속되면 가장 가까운 직원에게 도움을 요청하세요.`,
    ERROR_EDITING_ITEM: `장바구니의 상품을 편집하는 중 오류가 발생했습니다. 다시 시도해 주세요. 문제가 지속되면 가장 가까운 직원에게 도움을 요청하세요.`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `금액이 카드 잔액을 초과합니다.`,
    ERROR_CARD_CONFIRMATION: `죄송합니다! 카드를 확인할 수 없습니다. 다시 시도해 주세요.`,
    ERROR_CARD_DECLINED: `지정된 카드로 결제할 수 없습니다. 다시 시도해 주세요.`,
    ERROR_CARD_INACTIVE: `죄송합니다. 이 학생증은 활성화되어 있지 않습니다.`,
    ERROR_CARD_NOT_FOUND: `죄송합니다! 이 카드를 찾을 수 없습니다. 다시 시도해 주세요.`,
    ERROR_CARD_NUMBER_LENGTH: `카드 번호 길이가 올바르지 않습니다.`,
    ERROR_CARD_RESTRICTED_TIME: `죄송합니다. 이 카드는 현재 사용할 수 없습니다.`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `죄송합니다. 여기서는 {{$1: cardScheme}}을 사용할 수 없습니다. 다른 카드를 사용해 주세요.`,
    ERROR_COUPON_CONFIRMATION: `죄송합니다! 쿠폰 코드를 사용할 수 없습니다. 다시 시도해 주세요.`,
    ERROR_INVALID_EMAIL: `유효하지 않은 이메일 주소`,
    ERROR_INVALID_LOGIN_CREDS: `유효하지 않은 사용자 이름 또는 비밀번호`,
    ERROR_INVALID_NAME: `유효한 이름을 입력해 주세요`,
    ERROR_INVALID_PHONE_NUMBER: `유효한 전화번호를 입력해 주세요`,
    ERROR_INVALID_ROOM_NUMBER: `유효한 방 번호를 입력해 주세요`,
    ERROR_INVALID_TABLE_NUMBER: `유효한 테이블 번호를 입력해 주세요`,
    ERROR_INVALID_VERIFICATION_CODE: `유효하지 않은 인증 코드`,
    ERROR_KIOSK_CARD_DECLINED: `문제가 발생했습니다. 카드에서 결제가 이루어지지 않았습니다. 다시 시도해 주세요.`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `카드를 읽을 수 없습니다. 다시 시도해 주세요.`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `키오스크가 결제 장치를 찾을 수 없습니다. 카드에서 결제가 이루어지지 않았습니다. 직원에게 문의해 주세요.`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `결제 장치가 오프라인인 것 같습니다. 카드에서 결제가 이루어지지 않았습니다. 직원에게 문의해 주세요.`,
    ERROR_ORDER_OPERATION: `죄송합니다. 주문을 처리할 수 없습니다. 다시 시도해 주세요.`,
    ERROR_PIN_LENGTH: `PIN 길이가 올바르지 않습니다.`,
    ERROR_RECEIVING_PAYMENT: `단말기에서 결제를 처리할 수 없습니다. 다시 시도해 주세요.`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `결제가 접수되지 않았습니다. 이 주문은 전송되지 않았습니다. 영수증에 주문 요약이 포함됩니다. 추가 도움을 위해 직원에게 문의해 주세요.`,
    ERROR_SENDING_ORDER: `주방으로 주문을 보내는 중 문제가 발생한 것 같습니다. 직원에게 도움을 요청해 주세요.`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `결제는 성공했지만 주방으로 주문을 보내는 중 문제가 발생했습니다. 직원에게 문의해 주세요. 영수증에 주문 요약이 포함됩니다.`,
    ERROR_STARTING_ORDER: `죄송합니다. 주문을 시작할 수 없습니다. 다시 시도해 주세요. 문제가 지속되면 직원에게 문의해 주세요.`,
    ERROR_UPDATING_ORDER: `죄송합니다. 주문을 업데이트할 수 없습니다. 다시 시도해 주세요. 문제가 지속되면 직원에게 문의해 주세요.`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `이 상품을 볼 수 없습니다. 이 주문의 알코올 한도에 도달했습니다. 이 상품을 추가하려면 알코올 음료를 하나 제거해 주세요.`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `이 상품을 볼 수 없습니다. 이 주문의 특가 상품 한도에 도달했습니다. 이 상품을 추가하려면 특가 상품을 하나 제거해 주세요.`,
    EXIT: `종료`,
    EXIT_CONFIRMATION: `종료하시겠습니까? 종료하면 주문이 삭제됩니다.`,
    EXIT_TO_COVER: ``,
    FAVORITE: `즐겨찾기`,
    FAVORITES: `즐겨찾기`,
    FAVORITES_NONE_YET: `아직 즐겨찾기가 없습니다.`,
    FAVORITES_REMOVE_CONFIRMATION: `이 즐겨찾기를 삭제하시겠습니까?`,
    FETCHING_RECOMMENDATIONS: `추천 항목을 가져오는 중...`,
    FIND_ACCOUNT: `계정 찾기`,
    FIRST_NAME: `이름`,
    FORGOT_PASSWORD: `비밀번호를 잊으셨나요?`,
    FULFILLMENT_LABEL_ADDRESS: `주소`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `이메일`,
    FULFILLMENT_LABEL_GUEST_NAME: `수령인`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `주문 번호`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `테이블 번호`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `전화번호`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `추적 번호`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `차량 설명`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `주문이 아래 주소로 배달됩니다.`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `영수증을 보내드리겠습니다.`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `주문이 준비되면 성함을 불러드립니다.`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `주문 번호가 호출됩니다.`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `주문이 준비되면 문자로 알려드립니다.`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `주문이 테이블로 제공됩니다.`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `주문이 준비되면 트래커가 울립니다.`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `레스토랑 외부에 도착하시면 주문을 가져다드리겠습니다.`,
    FULFILLMENT_TOGGLE: `현재 수령 방법 전환`,
    FULL_NAME: `전체 이름`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `죄송합니다! 해당 시간대의 메뉴를 찾을 수 없습니다. 다시 시도해 주세요.`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `죄송합니다! 사용 가능한 시간대가 없습니다. 다른 식사 옵션을 시도해 주세요.`,
    FUTURE_ORDER_SET_FOR: `주문 예약 시간:`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `죄송합니다! 선택한 시간대를 더 이상 사용할 수 없습니다. 다른 시간을 선택해 주세요.`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `사용 가능한 시간대를 가져오는 중 오류가 발생했습니다. 다시 시도해 주세요. 문제가 지속되면 직원에게 문의해 주세요.`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `시간대를 선택해 주세요.`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `시간대`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `오늘`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `내일`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `오늘 {{$1: time}} 픽업`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `다음 영업일 {{$1: time}} 픽업`,
    FUTURE_ORDER_LEAD_TIME: `예상 주문 준비 시간: {{$1: time}}`,
    GENERIC_ERROR: `이런! 오류가 발생했습니다. 다시 시도해 주세요. 문제가 지속되면 직원에게 문의해 주세요.`,
    GET_REWARDS: `리워드 받기`,
    GET_RECEIPT: `영수증 받기`,
    GET_RECEIPT_DIALOG_TITLE: `영수증 옵션`,
    GIFT_CARD: `상품권`,
    GIFT_CARD_SECONDARY: `대체 상품권`,
    GIFT_CARD_TITLE: `지금 결제`,
    GIFT_CARD_SUBTITLE: `카드 리더기에서 상품권을 스와이프하여 결제하세요.`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `상품권 스캔 오류`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `상품권을 스캔할 수 없습니다. 다시 시도해 주세요.`,
    GIFT_CARD_APPLYING_TITLE: `상품권 적용 중`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `상품권 적용 오류`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `상품권을 적용할 수 없습니다. 다시 시도해 주세요.`,
    GIFT_CARD_NO_BALANCE_TITLE: `상품권 잔액 부족`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `상품권에 잔액이 없습니다.`,
    GIFT_CARD_ADD_ANOTHER: `다른 카드 추가`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `상품권 번호를 입력해 주세요.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `유효한 상품권 번호를 입력해 주세요.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `유효한 상품권 번호를 입력해 주세요.`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `PIN을 입력해 주세요.`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `유효한 PIN을 입력해 주세요.`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `유효한 PIN을 입력해 주세요.`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `상품권 번호를 입력하세요. 번호는 {{$1: length}}자리입니다.`,
    GIFT_CARD_ENTERING_PIN_HINT: `PIN을 입력하세요. 번호는 {{$1: length}}자리입니다.`,
    GIFT_CARD_ERROR_REMOVING: `상품권 삭제 중 오류가 발생했습니다. 다시 시도해 주세요. 문제가 지속되면 직원에게 문의해 주세요.`,
    'gift-card.select-account.title': `계정 선택`,
    'gift-card.select-account.loading': `계정 불러오는 중...`,
    'gift-card.select-account.error.title': `계정을 불러올 수 없음`,
    'gift-card.select-account.error.message': `계정을 불러올 수 없습니다. 다시 시도해 주세요.`,
    'gift-card.select-account.column.account': `계정`,
    'gift-card.select-account.column.balance': `현재 잔액`,
    'gift-card.select-account.error.toast-title': `오류`,
    'gift-card.select-account.error.toast-message': `확인에 실패했습니다. 다시 시도해 주세요.`,
    GLOSSARY_TERM_LEARN_MORE: `자세히 알아보기`,
    GOES_WELL_WITH: `잘 어울리는 메뉴`,
    GRAND_TOTAL: `합계`,
    GROUP_ORDERING_ADD_GUEST: `게스트 추가`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `게스트 이름에 유효하지 않은 문자가 포함되어 있습니다.`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `이 게스트 이름은 이미 사용 중입니다. 다른 이름을 입력해 주세요.`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `게스트 {{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `단체 주문 - 이 상품은 누구 것인가요?`,
    GROUP_ORDERING_LABEL: `단체 주문 - 상품 수령인:`,
    GROUP_ORDERING_TITLE: `단체 주문`,
    GROUP_ORDERING_SUBTITLE: `단체 주문 옵션은 각 상품이 그룹 내 어느 구성원의 것인지 확인합니다. 단체 주문을 활성화하려면 "예"를 누르세요. 계속하려면 "아니요"를 누르세요.`,
    GUEST_INFO: `게스트 정보`,
    GUEST_RATING_LABEL_0: `탭하여 0점으로 평가: 매우 불만족`,
    GUEST_RATING_LABEL_1: `탭하여 1점으로 평가: 다소 불만족`,
    GUEST_RATING_LABEL_2: `탭하여 2점으로 평가: 다소 만족`,
    GUEST_RATING_LABEL_3: `탭하여 3점으로 평가: 매우 만족`,
    GUEST_RATING_0: `후기에 대해 감사드립니다!`,
    GUEST_RATING_1: `후기에 대해 감사드립니다!`,
    GUEST_RATING_2: `후기에 대해 감사드립니다!`,
    GUEST_RATING_3: `후기에 대해 감사드립니다!`,
    GUEST_RATING_SUBMITTED: `후기에 대해 감사드립니다!`,
    HIDE: `숨기기`,
    HOME: `홈`,
    HOW_DID_WE_DO: `어떠셨나요? 평가해 주세요!`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `결제 방법을 선택해 주세요`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `주문 방법을 선택해 주세요`,
    KITCHEN_CLOSED: `죄송합니다. 주방이 현재 문을 닫았습니다.`,
    ID_CHECK_LABEL: `주문에 알코올이 포함되어 있습니다. 신분증 제시를 요청받을 수 있습니다.`,
    ID_CHECK_CODE_MESSAGE: `알코올 구매에는 직원 접근 코드가 필요합니다. 팀원에게 도움을 요청해 주세요.`,
    IE_WARNING: `인터넷 익스플로러에서 우리 사이트에 접속한 것이  발견되었습니다.  최상의 경험을 위해서는 구글 크롬이나 사파리, 파이어 폭스, 마이크로스프트 엣지와 같은 지원 브라우저를 열어주세요.`,
    INCLUDE_UTENSILS: `수저 포함`,
    ITEM_86D: `주방으로 주문을 보내는 중 품절 상품으로 인해 문제가 발생한 것 같습니다. 직원에게 도움을 요청해 주세요.`,
    ITEM_86D_VALIDATION: `재고 부족으로 주문을 주방에 전송하는데 문제가 있어 보입니다.  직원에게 도움을 요청하세요.`,
    ITEM_RECIPIENT: `담당:`,
    ITEM_RECIPIENT_FOR: `{{$1: recipient}} 님을 위해`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `추천`,
    ITEM_STEP_TITLE: `{{$1: step}}단계`,
    ITEM_STEP_EMPTY: `이 단계에서 선택이 없었습니다`,
    ITEM_STEP_NO_RECOS: `추천 항목 없음`,
    ITEMS_NO_LONGER_IN_MENU: `일부 상품이 더 이상 메뉴에 없어 장바구니에서 제거되었습니다`,
    ITEM_SCAN_ERROR: `이 상품을 찾을 수 없습니다. 메뉴에서 추가하시거나 직원에게 도움을 요청해 주세요.`,
    ITEM_SCAN_SUCCESS: `상품이 장바구니에 추가되었습니다!`,
    LAST_NAME: `성`,
    LEAD_TIME_LONG: `주문은 현재 선택된 시간대보다 더 오래 걸릴 수 있습니다.`,
    LEAD_TIME_CART: `선택한 상품으로 인해 이 주문은 요청한 픽업 시간보다 더 오래 걸릴 수 있습니다.`,
    LANGUAGE_SELECT_LABEL: `탭하여 언어 선택`,
    LOADING: `불러오는 중...`,
    LOADING_MENU: `메뉴 불러오는 중...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `매장 검색`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `{{$1: dine-in/take-away}} 매장 찾기`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `주문 방법은 무엇인가요?`,
    LOCATION_SEARCH_HEADER: `{{$1: org name}}에 오신 것을 환영합니다`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `주소, 시/도, 또는 우편번호`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `로그인`,
    LOGIN: `로그인`,
    LOGIN_GIFT_CARD: `상품권으로 로그인`,
    LOGIN_GIFT_CARD_SECONDARY: `대체 상품권으로 로그인`,
    LOGIN_WALL_WELCOME: `안녕하세요!`,
    LOGIN_WALL_WELCOME_USER: `안녕하세요, {{$1: user}} 님!`,
    LOGIN_WITH_CARD_NUMBER: `카드 번호로 로그인`,
    LOGIN_WITH_PHONE: `전화번호로 로그인`,
    LOOKING_UP_ACCOUNT: `계정 찾는 중...`,
    LOOKUP_CARD: `카드 찾는 중...`,
    LOOKUP_COUPON: `쿠폰 찾는 중...`,
    LOYALTY: `멤버십 프로그램`,
    LOYALTY_ACCOUNT_APPLY: `적용`,
    LOYALTY_CARD_NUMBER: `카드 번호`,
    LOYALTY_EXIT_TO_MENU: `메뉴로 이동`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `앱 QR 코드 스캔`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `앱이 없으신가요? 전화번호를 입력해 주세요.`,
    LOYALTY_AUTH_METHOD_BARCODE: `앱 QR 코드 스캔`,
    LOYALTY_AUTH_METHOD_HID: `HID 카드 탭`,
    LOYALTY_AUTH_METHOD_PHONE: `전화번호를 입력해 주세요.`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `카드 번호를 입력해 주세요.`,
    LOYALTY_AUTH_METHOD_EMAIL: `이메일을 입력해 주세요.`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `이메일과 비밀번호를 입력해 주세요.`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `이메일과 전화번호를 입력해 주세요.`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `사용자 이름과 비밀번호를 입력해 주세요.`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `계정 전화번호를 입력하세요:`,
    LOYALTY_APP_AUTH_SUBTITLE: `바코드를 찾으려면 앱에서 결제 화면을 여세요.`,
    LOYALTY_APP_AUTH_TITLE: `아래 스캐너로 앱의 결제 바코드를 스캔해 주세요.`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `7자리 리워드 코드 수동 입력`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `7자리 리워드 코드를 입력하세요:`,
    LOYALTY_APPLY_REWARD_FAILED: `리워드 적용에 실패했습니다. 다시 시도해 주세요.`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `다음 리워드를 적용할 수 없습니다: {{$1: reward names}}. 다시 시도해 주세요.`,
    LOYALTY_APPLYING_REWARD: `리워드 적용 중...`,
    LOYALTY_AUTH_GENERIC_ERROR: `죄송합니다! 이 리워드 계정을 찾을 수 없습니다. 다시 시도해 주세요.`,
    LOYALTY_AUTH_INSTRUCTIONS: `포인트를 적립하고 사용하려면 로그인하세요.`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `사용 가능한 리워드`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `현재 잔액`,
    LOYALTY_CANNOT_MODIFY_REWARD: `죄송합니다. 주문 결제 후에는 리워드를 변경할 수 없습니다.`,
    LOYALTY_CANNOT_REMOVE_REWARD: `죄송합니다. 이 리워드는 주문에 적용된 후 삭제할 수 없습니다.`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `카드 번호를 입력하여 포인트를 적립하고 사용하세요.`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `죄송합니다. 쿠폰이 적용되어 있어 리워드를 사용할 수 없습니다.`,
    LOYALTY_GETTING_REWARDS: `리워드를 가져오는 중...`,
    LOYALTY_FETCH_REWARDS_FAILED: `리워드를 가져오는 데 실패했습니다. 다시 시도해 주세요.`,
    LOYALTY_REWARD_APPLY: `적용`,
    LOYALTY_REWARD_APPLY_FAILED: `리워드 적용에 실패했습니다. 일부 리워드는 주문에 적용되지 않을 수 있습니다.`,
    LOYALTY_REWARD_APPLIED: `적용됨`,
    LOYALTY_REWARD_INVALID: `유효하지 않음`,
    LOYALTY_REWARD_LABEL_MEAL: `식사`,
    LOYALTY_REWARD_LABEL_MEALS: `식사`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `지금 교환`,
    LOYALTY_REWARD_LABEL_SELECTED: `선택됨`,
    LOYALTY_REWARD_LABEL_APPLIED: `교환됨`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `결제 시 교환`,
    LOYALTY_REWARD_LABEL_REMOVING: `삭제 중`,
    LOYALTY_REWARD_LABEL_ERROR: `적용 오류`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `적용 불가`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `리워드`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `비율 기반 리워드`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `고정 리워드`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `지갑 리워드`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `지갑 및 결제 리워드`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `무료 상품 리워드`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `식사 교환 리워드`,
    LOYALTY_REWARDS_FOR: `...를 위해`,
    LOYALTY_NO_REWARDS_LABEL: `리워드 없음`,
    LOYALTY_NO_REWARDS_NO_EARNING: `이 상품에 적용 가능한 리워드가 없습니다.`,
    LOYALTY_NO_REWARDS_TEXT: `이 상품에 적용 가능한 리워드는 없지만 이 주문으로 포인트는 적립됩니다!`,
    LOYALTY_PAYMENT: `멤버십 포인트 결제`,
    LOYALTY_PAYMENT_CARD_CHARGED: `등록된 카드에 {{$1: charge_amount}}가 청구됩니다.`,
    LOYALTY_PAYMENT_FAILED: `결제 적용에 실패했습니다.`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `멤버십 포인트 결제 처리 중 문제가 발생했습니다. 다시 시도하거나 다른 결제 방법을 선택해 주세요.`,
    USE_LOYALTY_PAYMENT: `멤버십 포인트 사용`,
    LOYALTY_PAYMENT_SUBMIT: `결제 완료`,
    LOYALTY_PAYMENT_REWARD: `멤버십에서 청구됨`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `제공업체에 등록된 카드에 이 거래 비용이 청구됩니다.`,
    LOYALTY_PAY_WITH_APP: `앱으로 결제`,
    LOYALTY_EARNED_POINT_ESTIMATE: `이 주문의 예상 리워드 포인트:`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number}} 포인트`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `계정 상태`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `계정을 찾을 수 없습니다.`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `포인트를 적립하고 리워드를 교환하려면 아래에서 계정에 로그인하세요.`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `전화번호로 가입`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `가입 후 영수증을 스캔하면 오늘 주문의 포인트를 적립할 수 있습니다!`,
    LOYALTY_INTRO_QR_SIGN_IN: `아래 QR 코드를 스캔하여 로그인하세요.`,
    LOYALTY_INTRO_QR_SIGN_UP: `아래 QR 코드를 스캔하여 가입하세요.`,
    LOYALTY_INTRO_WELCOME_BACK: `다시 오셨군요,`,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `제공한 전화번호가 여러 멤버십 계정과 연결되어 있거나 존재하지 않습니다.`,
    LOYALTY_REDEMPTION_CODE: `교환 코드 적용`,
    LOYALTY_REMOVING_REWARD: `리워드 삭제 중...`,
    LOYALTY_SCAN_FAILED_TITLE: `스캔 실패`,
    LOYALTY_SCAN_FAILED_MESSAGE: `QR 코드를 스캔할 수 없습니다. 다시 시도해 주세요.`,
    LOYALTY_SIGN_OUT_NOTICE: `주문이 완료되거나 메뉴를 종료하면 자동으로 로그아웃됩니다.`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `주문이 완료되거나 메뉴를 종료하면 자동으로 로그아웃됩니다. 비밀번호는 저장되지 않습니다.`,
    LOYALTY_SIGN_UP_SMS_SENT: `가입 메시지가 전송되었습니다!`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `로그인으로 돌아가기`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `가입 완료!`,
    LOYALTY_SIGN_UP_WITH_QR: `QR 코드로 가입`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `전화번호로 가입`,
    LOYALTY_WELCOME_TITLE: `포인트 적립 및 사용`,
    LOYALTY_SIGNUP_TITLE: `전화로 가입 링크 받기`,
    LOYALTY_YOU_CURRENTLY_HAVE: `현재 보유하신 포인트`,
    LOYALTY_NAV_REWARDS: `내 리워드`,
    LOYALTY_NAV_ORDER_HISTORY: `주문 내역`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `최대 로그인 시도 횟수를 초과했습니다.`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `최대 상품권 접근 시도 횟수를 초과했습니다.`,
    MAKE_IT_A_COMBO: `세트로 만드시겠어요?`,
    MAKE_IT_A_COMBO_MOD: `콤보로 하시겠습니까?`,
    MAKE_IT_A_COMBO_ACCEPT: `네, 부탁드립니다!`,
    MAKE_IT_A_COMBO_REJECT: `아니요, 괜찮습니다!`,
    MAKE_IT_A_COMBO_NO: `아니요, 세트 없이요`,
    MAKE_IT_A_COMBO_YES: `세트로 만드시겠어요?`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `좋은 선택이에요!`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `아래에서 사이드와 음료를 선택해 주세요!`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `사이드와 음료를 추가하여 세트로 만들어 보세요!`,
    MENU_COVER_ALT_TEXT: `여기를 탭하여 주문 시작`,
    MENU_COVER_LOYALTY_TEXT: `포인트 적립 및 리워드 교환을 위해 멤버십에 로그인`,
    MENU_COVER_QUIZ_TEXT: `퀴즈를 통해 나에게 맞는 메뉴를 찾아보세요!`,
    MENU_COVER_WAYFINDER_TEXT: `안내 지도에서 원하는 곳을 찾아보세요`,
    MAINTENANCE_COVER_TITLE: `이 키오스크는 점검 중입니다`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `HID가 키오스크에 연결되어 있는지 확인해 주세요.`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `HID 연결 끊김`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `KDS가 키오스크에 연결되어 있는지 확인해 주세요.`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `KDS 연결 끊김`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `다른 키오스크를 사용하거나 직원에게 도움을 요청해 주세요.`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `이 키오스크는 현재 사용할 수 없습니다`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `자기 띠 리더기가 키오스크에 연결되어 있는지 확인해 주세요.`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `자기 띠 리더기 연결 끊김`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `키오스크가 네트워크에 연결되어 있는지 확인해 주세요.`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `네트워크 연결 없음`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `인터넷 속도가 느려 이 키오스크의 연결에 문제가 있습니다. 연결이 안정적인지 확인해 주세요. 권장 속도: 업로드 및 다운로드 최소 10Mbps.`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `불안정한 네트워크 감지됨`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `결제 장치가 켜져 있고 키오스크에 연결되어 있는지 확인해 주세요.`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `결제 장치 연결 끊김`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `프린터 덮개가 닫혀 있는지 확인해 주세요.`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `프린터 덮개 열림`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `프린터가 키오스크에 연결되어 있는지 확인해 주세요.`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `프린터 연결 끊김`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `프린터에 용지가 있는지 확인해 주세요.`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `프린터 용지 없음`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `저울이 키오스크에 연결되어 있는지 확인해 주세요.`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `저울 연결 끊김`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `스캐너가 키오스크에 연결되어 있는지 확인해 주세요.`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `스캐너 연결 끊김`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `주문당 알코올 음료 최대 수량은 {{$1: number}}개입니다`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `주문당 특가 상품 최대 수량은 {{$1: number}}개입니다`,
    MENU_COVER_DINING_OPTIONS: `어떻게 주문하시겠습니까?`,
    MENU_COVER_LANGUAGE_OPTIONS: `시작하려면 언어를 선택하세요`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `여기를 탭하여 주문을 시작하고 이 추천 상품을 확인하세요: {{$1: item name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `여기를 탭하여 주문을 시작하고 이 추천 섹션으로 바로 이동하세요: {{$1: section name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `여기를 탭하여 주문을 시작하고 이 추천 페이지로 바로 이동하세요: {{$1: page name}}!`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `"{{$1: fulfillment method}}" 주문을 시작하려면 여기를 탭하세요!`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `식사 옵션으로 돌아가기`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `전화번호로 돌아가기`,
    MARKETING_CONSENT: `뉴스, 업데이트, 할인 및 프로모션을 받고 싶습니다`,
    MENU_FILTERS_DIETARY_FILTERS: `식단 옵션`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `건강식을 원하면 매뉴에서 건강식만 보여주는 이들 옵션 중 하나를 선택하세요.`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `영양 선호도`,
    MENU_FILTERS_OTHER_FILTERS: `기타`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `제한적`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `피해야 할 특정 품목이 있을 경우, 이들 중 하나를 선택하면 그것이 매뉴에서 보이지 않습니다.`,
    MENU_FILTERS_COUNT: `{{$1: number}}개 영양 선호도 활성화. 탭하여 편집하세요.`,
    MOD_86D: `식재료 부족으로 주문을 주방에 전송하는데 문제가 있어 보입니다.  직원에게 도움을 청하세요.  대금을 식당에서 수령했다는 것을 유념하십시오.`,
    MOD_GROUP_AGGREGATE_QUANTITY: `총 {{$1: number range, e.g. 2-3}} 품목`,
    MOD_GROUP_CHOICES_INCREMENT: `{{$1: number, e.g. you have to get 2/4/6 sauces}} 중의 다수`,
    MOD_GROUP_CHOICES_MAKE_ONE: `특별한 품목을 하나 선택하세요`,
    MOD_GROUP_CHOICES_MAKE_X: `{{$1: number range, e.g. 2-3}}의 다른 선택을 하세요`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `선택 당 {{$1: number range, e.g. 2-3}}`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `최소 {{$1: number}}개 선택`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `{{$1: number}}~{{$2: number}}개 선택`,
    MOD_GROUP_CHOOSE_ONE: `1개 선택`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `최대 1개 선택`,
    MOD_GROUP_CHOOSE_UP_TO_X: `최대 {{$1: number}}개 선택`,
    MOD_GROUP_CHOOSE_X: `{{$1: number}}개 선택`,
    MOD_GROUP_DEEMPHASIZE_SHOW: `표시 - {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `숨기기 - {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: `청구되기 전에 {{$1: dollar amount}}을 사용할 수 있습니다.`,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: `선택 당 {{$1: dollar amount}}에서 추가 선택`,
    MOD_GROUP_WALLET_FIRST_X_FREE: `처음 {{$1: number}}는 무료입니다.`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `첫 번째는 무료입니다.`,
    MOD_GROUP_WALLET_UP_TO_X: `선택 당 {{$2: dollar amount}}에서 {{$1: number}}까지`,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `대체 닫기`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `대체 변경`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `대체`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `상품에 추가`,
    MOD_RECOMMENDED_BADGE: `추천`,
    MOD_UPSELL_PROMPT_TITLE: `옵션 추가하시겠어요?`,
    MOD_UPSELL_PROMPT_ACCEPT: `추가`,
    MOD_UPSELL_PROMPT_DECLINE: `아니요, 괜찮습니다`,
    MODIFY: `수정`,
    MODIFY_INGREDIENTS: `재료 수정`,
    MORE: `더 보기`,
    NAME_CALLED_ORDER_READY: `주문이 준비되면 성함을 불러드립니다.`,
    NAME_ON_CARD: `카드 명의인`,
    NEED_MORE_TIME: `시간이 더 필요하신가요?`,
    NEW_PASSWORD: `새 비밀번호`,
    NEXT: `다음`,
    NO: `아니요`,
    NO_ITEMS_MATCH_FILTERS: `필터에 맞는 상품이 없습니다.`,
    NO_ORDERS_MATCH: `검색에 맞는 주문이 없습니다.`,
    NO_THANKS: `아니요, 괜찮습니다`,
    NO_TIP: `팁 없음`,
    NOT_A_MEMBER: `아직 회원이 아니신가요?`,
    NUTRITION_INFO_CALORIES: `칼로리`,
    NUTRITION_INFO_PROTEIN: `단백질`,
    NUTRITION_INFO_FAT: `지방`,
    NUTRITION_INFO_CARBS: `탄수화물`,
    NUTRITION_INFO_SUGAR: `당류`,
    OK: `확인`,
    OR: `또는`,
    OPT_OUT_OF_RECOMMENDATIONS: `추천 거부`,
    ORDER_GET_ERROR: `죄송합니다. 주문을 생성하는 중 문제가 발생했습니다. 다시 시도해 주세요.`,
    ORDER_HISTORY: `주문 내역`,
    ORDER_HISTORY_EMPTY: `주문 내역이 없습니다. 주문하시면 여기에 표시됩니다.`,
    ORDER_HISTORY_ERROR: `죄송합니다. 주문 내역을 불러오는 중 문제가 발생했습니다. 다시 시도해 주세요.`,
    ORDER_SENT: `주문이 전송되었습니다`,
    ORDER_SUMMARY: `주문 요약`,
    ORDER_SUMMARY_WITH_NAME: `{{$1 guest name}} 님의 주문 요약`,
    ORDER_SUMMARY_LABEL: `주문 요약. {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `주문 요약. {{$2 guest name}} 님의 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `주문 요약. {{$2: table number}}번 테이블의 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `주문 요약. 트래커 #{{$2: tracker number}}의 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `주문 요약. {{$3: table number}}번 테이블의 {{$2 guest name}} 님을 위한 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `주문 요약. 트래커 #{{$3: tracker number}}의 {{$2 guest name}} 님을 위한 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `주문 요약. 주문 #{{$2: order number}}의 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `주문 요약. 트래커 #{{$2: tracker number}}, 주문 #{{$3: order number}}의 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `주문 요약. {{$2: table number}}번 테이블, 주문 #{{$3: order number}}의 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `주문 요약. {{$2 guest name}} 님, 주문 #{{$3: order number}}의 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `주문 요약. {{$3: table number}}번 테이블의 {{$2 guest name}} 님, 주문 #{{$4: order number}}의 {{$1 fulfillment}} 주문`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `주문 요약. 트래커 {{$3: tracker number}}의 {{$2 guest name}} 님, 주문 #{{$4: order number}}의 {{$1 fulfillment}} 주문`,
    ORDER_THROTTLE_MAX_EXCEEDED: `죄송합니다! 레스토랑이 처리할 수 있는 것보다 더 많은 주문을 받고 있습니다. 다른 시간대로 시도해 주세요.`,
    ORDER_TIME_ASAP: `최대한 빨리 주문`,
    ORDER_TIME_LATER: `오늘 나중에`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `다음 영업일`,
    ORDER_TIME_FUTURE: `나중에 주문`,
    ORDER_TOTAL_MAX_EXCEEDED: `대량 주문은 직원에게 문의해 주세요.`,
    ORDER_UPDATE_FAILED: `주문 업데이트에 실패했습니다.`,
    ORDER_VALIDATION_IN_PROGRESS: `주문 확인 중`,
    ORDER_VALIDATION_FAILED: `이런! 오류가 발생했습니다.`,
    ORDER_WAS_PLACED: `주문이 완료되었습니다.`,
    ORDERING_MODE_CHANGED: `주문 모드가 변경되었습니다. 세션이 초기화되었습니다.`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `{{$1: ordered item name}}을(를) 세트로 만들려면 여기를 탭하세요.`,
    ORDERED_ITEM_COMBO_LABEL: `세트`,
    ORDERING_ITEM_ABSENCE_RESET: `이 상품은 오래된 정보입니다. 상품이 초기 상태로 재설정되었습니다. 다시 시도해 주세요.`,
    OUR_MENU: `메뉴`,
    OUTPOST_PICKUP: `전진 기지 픽업`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `전진 기지 방 번호 입력`,
    OUTPOST_ROOM_NUMBER_TITLE: `방 번호`,
    OUT_OF_STOCK: `품절`,
    PAGE_NAVIGATION_TITLE: `아래 옵션 중 하나를 탭하여 메뉴의 특정 페이지로 이동하세요. {{$1: total}}개 페이지 이용 가능.`,
    PAGE_NOT_FOUND: ``,
    PAGE_NOT_FOUND_MESSAGE: ``,
    PAGE_ERROR: ``,
    PAGE_ERROR_MESSAGE: ``,
    GO_TO_HOME_PAGE: ``,
    PARTIAL_PAYMENT_LINE: `부분 결제`,
    PARTIAL_PAYMENT_WARNING_TITLE: `부분 결제`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `이 주문에 부분 결제가 있습니다. 돌아가려면 먼저 결제가 환불됩니다.`,
    PASSWORD: `비밀번호`,
    PASSWORD_REQUIREMENTS: ``,
    PASSWORD_UPDATED: ``,
    PASSWORD_UPDATED_LOG_IN_AGAIN: ``,
    PARTIAL_TENDER_TIMEOUT: `5분 내에 결제를 완료하지 않으시면 주문을 취소하고 결제를 환불해 드립니다.`,
    PAY_AT_CASHIER: `계산대로 가서 결제해 주세요.`,
    PAY_NOW: `지금 결제`,
    PAY_WITH: `결제 방법`,
    PAY_WITH_CREDIT: `신용카드로 결제`,
    PAY_WITH_DEBIT_CREDIT: `직불/신용으로 결제`,
    PAYMENT: `결제`,
    PAYMENT_DETAILS: `결제 세부 정보`,
    PAYMENT_LINE_LABEL_DONATION: `{{$1: amount}} 기부`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `소계는 {{$1: amount}}입니다`,
    PAYMENT_LINE_LABEL_PARTIAL: `{{$1: amount}} 부분 결제`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `{{$1: name}} 상품권 사용 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COUPON: `{{$1: name}} 쿠폰 할인 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `{{$1: name}} 쿠폰 할인 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `EBT 결제 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_LOYALTY: `{{$1: name}} 리워드 사용 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `{{$1: name}} 리워드 사용 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `{{$1: name}} 할인 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `세금은 {{$1: amount}}입니다`,
    PAYMENT_LINE_LABEL_TIP: `팁은 {{$1: amount}}입니다`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `서비스 요금 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `{{$2: name}} 서비스 요금 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TOTAL: `합계는 {{$1: amount}}입니다`,
    PAYMENT_LINE_LABEL_REMAINING: `남은 잔액은 {{$1: amount}}입니다`,
    PAYMENT_LINE_LABEL_PAID: `결제 금액은 {{$1: amount}}입니다`,
    PAYMENT_OPTION_LABEL_CASH: `탭하여 현금으로 결제`,
    PAYMENT_OPTION_LABEL_CARD: `탭하여 신용카드로 결제`,
    PAYMENT_OPTION_LABEL_COUPON: `탭하여 쿠폰 사용`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `탭하여 컴프 카드 사용`,
    PAYMENT_OPTION_LABEL_DONATION: `탭하여 기부하기 또는 기부 편집`,
    PAYMENT_OPTION_LABEL_EBT: `탭하여 EBT로 결제`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `탭하여 EBT 환불`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `탭하여 EBT 현금 혜택으로 결제`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `탭하여 EBT 푸드 스탬프로 결제`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `탭하여 상품권으로 결제`,
    PAYMENT_OPTION_LABEL_LOYALTY: `탭하여 리워드 사용`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `탭하여 리워드 사용`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `탭하여 결제 완료`,
    PAYMENT_PROMPT_NFC: `카드를 삽입하거나 휴대폰을 가까이 대어 결제하세요.`,
    PAYMENT_PROMPT_DIP: `카드를 삽입하여 결제하세요.`,
    PAYMENT_SUCCESSFUL: `결제 성공`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `죄송합니다. 결제에 실패했습니다. 다시 시도해 주세요.`,
    PAYMENT_KIOSK_TIMEOUT: `죄송합니다. 결제 세션이 만료되었습니다. 다시 시도해 주세요.`,
    PAYMENT_TOTAL: `결제 합계`,
    PAYMENT_WAS_TAKEN: `결제가 처리되었음을 확인해 주세요.`,
    PAYMENT_WAS_NOT_TAKEN: `결제가 처리되지 않았음을 확인해 주세요. 이것은 결제 확인이 아닙니다.`,
    PHONE_NUMBER: `전화번호`,
    PICK_UP: `픽업`,
    PICK_UP_AT: `픽업 장소`,
    PICK_UP_ENTER_NUMBER: `번호를 받아 아래에 입력해 주세요:`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `안녕하세요 {{$1: guest name}}, 번호를 받아 아래에 입력해 주세요:`,
    PICK_UP_ENTER_NUMBER_TRACKER: `트래커를 받아 번호를 입력해 주세요:`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `안녕하세요 {{$1: guest name}}, 트래커를 받아 번호를 입력해 주세요:`,
    PLACE_ORDER: `주문하기`,
    PLEASE_ENTER_A_VALID_AMOUNT: `유효한 환불 금액을 입력해 주세요.`,
    PLEASE_USE_TEST_CARD: `이 위치는 아직 테스트 모드입니다. 테스트 카드로 결제해 주세요.`,
    PLEASE_WAIT: `잠시 기다려 주세요...`,
    PRICE: `가격은 {{$1:price}}입니다`,
    PRINTING_RECEIPT: `영수증 인쇄 중...`,
    PRINT_RECEIPT: `영수증 인쇄`,
    PRINT_RECEIPT_ERROR: `죄송합니다. 영수증 인쇄 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.`,
    PRINTED_RECEIPT_COMMAND: `영수증을 꼭 가져가세요!`,
    PROCESSING_PAYMENT: `결제 처리 중...`,
    PROMOTED_MODIFIER: `특별 할인이 적용되었어요!`,
    QUANTITY_SELECT: `{{$1:quantity}}개 선택됨`,
    QUANTITY_SELECT_INCREASE: `수량 증가`,
    QUANTITY_SELECT_DECREASE: `수량 감소`,
    QUANTITY_SELECT_LABEL: ``,
    QUIT: `종료`,
    QUICK_CHECKOUT: `빠른 결제`,
    QUICK_NAV_TAP_TO_VIEW: `탭하여 보기:`,
    QUIZ_RESULTS_TITLE: `결과`,
    QUIZ_RESULTS_EMPTY: `결과를 찾을 수 없습니다. 다른 답변으로 다시 시도해 주세요.`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `탭하여 다음 결과 보기. {{$2:total}} 중 {{$1:index}}`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `탭하여 이전 결과 보기. {{$2:total}} 중 {{$1:index}}`,
    QUIZ_STEP_ERROR: `계속하기 전에 모든 질문에 답해 주세요.`,
    QUIZ_STEP_ANSWER_LABEL: `탭하여 {{$1:badge name}}(으)로 답하기:`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `QR 코드를 스캔하여 휴대폰으로 영수증 사본을 받으세요.`,
    RECEIPT_AUTHORIZATION: `승인`,
    RECEIPT_CARD_NUMBER: `카드 번호`,
    RECEIPT_CHECK_ID: `영수증 번호를 확인하세요`,
    RECEIPT_DISCOUNTS: `할인`,
    RECEIPT_DONATION: `기부`,
    RECEIPT_FAILED: `주방으로 주문을 보내는 중 문제가 발생한 것 같습니다. 직원에게 도움을 요청해 주세요.`,
    RECEIPT_FAILED_ITEM_86D: `식재료 부족으로 손님의 주문을 주방에 전송하는데 문제가 있어 보입니다.  직원에게 도움을 청하세요.`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `다음 품목들은 관련된 PLU(가격조회코드)가 없기 때문에 QR 코드에 포함되지 않았습니다:`,
    RECEIPT_NOT_RECEIPT: `이것은 영수증이나 구매 증빙이 아닙니다.`,
    RECEIPT_ORDER: `주문`,
    RECEIPT_ORDER_TOTAL: `주문 합계`,
    RECEIPT_PAY_AT_CASHIER: `계산대에서 결제해 주세요`,
    RECEIPT_PICK_UP_AT_LABEL: `픽업 장소`,
    RECEIPT_PICKUP_TIME_LABEL: `픽업 시간`,
    RECEIPT_DELIVERY_TIME_LABEL: `배달 시간`,
    RECEIPT_PRINTED: `영수증이 인쇄되었습니다`,
    RECEIPT_REFUNDED: `환불됨`,
    RECEIPT_REMAINING_BALANCE: `잔액`,
    RECEIPT_SELF_SERVE: `셀프 서비스`,
    RECEIPT_SPECIAL_REQUEST: `특별 요청`,
    RECEIPT_SUB_TOTAL: `소계`,
    RECEIPT_TAX_TOTAL: `세금 합계`,
    RECEIPT_TIP_THANKS: `팁 (감사합니다!)`,
    RECEIPT_SERVICE_CHARGE: `서비스 요금`,
    RECEIPT_TRANS_NO: `무인기 거래 번호`,
    RECEIPT_YOUR_CHECK_NUMBER: `계산서 번호는`,
    RECOMMENDATIONS: `추천`,
    RECOMMENDED_FOR_YOU: `회원님을 위한 추천`,
    REFUND: `환불`,
    REFUNDER_ALREADY_REFUNDED: `환불됨`,
    REFUNDER_DELAY_MESSAGE: `환불은 계정 명세서에 나타나는 데 며칠이 걸릴 수 있습니다.`,
    REFUNDER_INSTRUCTIONS: `영수증의 승인 번호나 주문번호, 이메일주소, 전화번호, 카드의 마지막 4자리수, 거래 참조번호, 또는 주문 ID번호를 사용하여 주문을 검색하세요.`,
    REFUNDER_SEARCH_PLACEHOLDER: `영수증 승인 번호, 주문 번호 또는 카드의 마지막 4자리 숫자`,
    REFUNDER_TITLE: `주문 환불`,
    REFUNDER_SEARCHING_TITLE: `검색 중`,
    REFUNDER_RESULTS_TITLE: `주문`,
    REFUNDER_RESULTS_EMPTY: `주문을 찾을 수 없습니다. 검색 기준을 확인하고 다시 시도해 주세요.`,
    REFUNDER_REFUNDING_TITLE: `환불 처리 중`,
    REFUNDER_REFUND_ERROR: `환불 처리 중 오류가 발생했습니다. 다시 시도해 주세요. 문제가 지속되면 고객 지원에 문의해 주세요.`,
    REFUNDER_REFUND_SUCCESS: `환불 성공! 거래가 곧 처리됩니다.`,
    REFUNDER_REFUND_SUCCESS_BACK: `다시 검색`,
    REFUNDER_SEARCH_INPUT_ERROR: `유효한 승인 번호, 주문 번호 또는 카드 마지막 4자리를 입력해 주세요.`,
    REFUNDER_SEARCH_ERROR: `주문을 검색하는 중 오류가 발생했습니다. 다시 시도해 주세요. 문제가 지속되면 고객 지원에 문의해 주세요.`,
    REFUNDING: `환불 처리 중...`,
    REFUND_FAILED: `환불에 실패했습니다. 나중에 다시 시도해 주세요.`,
    REMOVE: `삭제`,
    REMOVE_CARD: `카드를 잊지 말고 가져가세요.`,
    REMOVE_COMP_CARD: `컴프 카드 삭제`,
    REMOVE_COUPON: `쿠폰 삭제`,
    REMOVE_GIFT_CARD: `삭제`,
    REMOVE_TIP: `팁 삭제`,
    REMOVING_COUPON: `쿠폰 삭제 중...`,
    REORDER: ``,
    REPEAT_PASSWORD: `비밀번호 재입력`,
    RESET: `초기화`,
    REWARDS: `리워드`,
    REWARDS_LOGGED_IN: `리워드`,
    REWARDS_APPLICABLE_TO_ORDER: `지금 주문에 적용 가능`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `아직 주문에 적용 불가`,
    REWARDS_EDIT: `리워드 편집`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}}  포인트`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}}회 식사`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}}  포인트`,
    SAVE: `업데이트`,
    SAVE_CARD: `향후 구매를 위해 카드를 계정에 저장합니다.`,
    SCAN_COUPON_BELOW: `아래 스캐너로 쿠폰을 스캔할 수 있습니다.`,
    SCAN_YOUR_GIFT_CARD: `상품권 스캔`,
    SEARCH: `검색`,
    SEARCH_BEGIN: `검색을 시작하려면 아래에 검색어를 입력하세요.`,
    SEARCH_EMPTY: `결과를 찾을 수 없습니다. 다른 검색어를 시도해 주세요.`,
    SEARCH_HINT: `이름이나 설명의 조합으로 상품을 검색하세요.`,
    SECRET_MENU_IMAGE_ALT: `탭하여 시크릿 메뉴 보기`,
    SELECT_DATE: `날짜 선택`,
    SELF_SERVE: `셀프 서비스`,
    SEND: `전송`,
    SEND_LOYALTY_SMS: `SMS 전송`,
    SEND_ORDER_UI_TIMEOUT: `손님의 주문을 주방에 전송하는 시도를 계속하고 있습니다.  직원에게 도움을 청하세요.`,
    SENT_LOYALTY_SIGNUP_SMS: `SMS가 전송 되었습니다! 전화를 확인하고 편리한 시간에 등록하세요`,
    SENDING_ORDER_KITCHEN: `주방으로 주문 전송 중...`,
    SENDING_ORDER_VALIDATION: `주문 확인 중...`,
    SENDING_RECEIPT: `영수증 전송 중...`,
    SENDING_SMS: `SMS 전송 중...`,
    SERVICE_CHARGE: `서비스 요금`,
    SHOW: `표시`,
    SHOW_NUTRITION: `영양 정보 표시`,
    SHOW_STAFF_FIRST: `나가기 전에 이 메시지를 직원에게 보여주세요.  \n정말로 나가시나요?`,
    SIGNUP_CTA: `계정을 만드시려면 등록하세요!`,
    SIGN_OUT: `로그아웃`,
    SIGN_UP: `가입`,
    SIGNUP_BENEFITS: `계정을 만들어 신용카드와 즐겨찾기 상품을 저장하여 더 빠른 결제를 즐기세요.`,
    SIGNUP_LOYALTY: `멤버십 프로그램 가입`,
    SKIP: `건너뛰기`,
    SPECIAL_REQUESTS: `특별 요청`,
    SPECIAL_REQUESTS_EXAMPLE: `예: 소스 따로, 안초비 없이 등`,
    SPECIAL_REQUESTS_FINEPRINT: `변경 및 특별 요청에는 추가 요금이 발생할 수 있습니다.`,
    SPECIAL_REQUESTS_ADD: `특별 요청 추가`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `특별 요청이 너무 깁니다.`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `문자, 숫자, 문장 부호만 사용해 주세요.`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `특별 요청을 입력해 주세요.`,
    SR_REMOVE_ITEM_FROM_CART: `장바구니에서 품목 삭제`,
    STARTING_ORDER: `주문 시작 중...`,
    UPDATING_ORDER: `주문 업데이트 중...`,
    START_ORDER_BY_SCANNING: `키오스크 하단에서 상품을 스캔하여 주문을 시작하세요.`,
    START_NEW_ORDER: `다른 주문하기`,
    STORED_VALUE_REMAINING_BALANCE: `잔고`,
    STORE_INFO: ``,
    STORE_INFORMATION: `매장 정보`,
    STUDENT_CARD: `학생증`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `죄송합니다. 이 학생증의 잔액이 부족합니다.`,
    STUDENT_CARD_SUBTITLE_HID: `학생증을 탭하여 결제`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `학생증을 탭하거나 스와이프하여 결제`,
    STUDENT_CARD_SUBTITLE_MSR: `학생증을 스와이프하여 결제`,
    SUBMIT: `제출`,
    SUBTOTAL: `소계`,
    SUBTOTAL_REDUCED: `할인된 소계`,
    SUBTOTAL_INCREASED: `새로운 소계`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `세트로 절약하고 계세요!`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `절약 금액`,
    SUCCESS: `성공`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `매장 변경`,
    SWITCH_TO_CATERING: `케이터링으로 전환`,
    SWITCH_TO_WEB: `온라인 주문으로 전환`,
    SWIPE_YOUR_GIFT_CARD: `상품권을 스와이프하여 결제`,
    SWIPE_YOUR_COMP_CARD: `컴프 카드를 스와이프하여 결제`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `상품권을 스와이프하거나 스캔하여 결제`,
    TAKING_LONGER_THAN_USUAL: `평소보다 더 오래 걸리고 있습니다...`,
    TAP_HERE_FOR_LANGUAGE: `{{$1: language}}은 여기를 탭하세요`,
    TAP_OUTSIDE_CLOSE: `밖을 탭하여 닫기`,
    TAP_TO_REDEEM: `탭하여 교환`,
    TAXES: `세금`,
    TERMS_OF_SERVICE: `서비스 약관`,
    TERMS_OF_SERVICE_LOAD_FAILED: `서비스 약관 불러오기 오류`,
    TEXT_RECEIPT: `문자 영수증`,
    TEXT_RECEIPT_SEND_FAILED: `문자 영수증을 보낼 수 없습니다.`,
    TEXT_RECEIPT_SEND_SUCCESS: `영수증이 전송되었습니다!`,
    TEXT_YOU_WHEN_READY: `주문이 준비되면 문자로 알려드립니다.`,
    THANK_YOU: `감사합니다!`,
    THEN_PRESS_BUTTON_1: `그러면 버튼을`,
    THEN_PRESS_BUTTON_2: `누르세요.`,
    TIP: `팁`,
    TIPPING: `팁 추가 중...`,
    TIP_AMOUNT_TOO_HIGH: `팁 금액이 너무 높습니다.`,
    TIP_AMOUNT_TOO_LOW: `팁 금액이 너무 낮습니다.`,
    TIP_FAILED: `죄송합니다! 팁을 추가할 수 없습니다. 다시 시도해 주세요.`,
    TIP_CANNOT_BE_MODIFIED: `죄송합니다! 주문 결제 후에는 팁을 변경할 수 없습니다.`,
    TIP_LABEL_PERCENT: `탭하여 {{$1: percent}}% ({{$2: amount}}) 팁 추가`,
    TIP_LABEL_FIXED: `탭하여 {{$1: amount}} 팁 추가`,
    TIP_LABEL_CUSTOM: `탭하여 직접 입력 팁 추가`,
    TIP_LABEL_NONE: `탭하여 팁 제거`,
    TO_GO: `포장`,
    TOTAL: `합계`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `주문의 일부 상품 가격이 변경되었습니다.`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `소계가 변경되었고 이제`,
    TOTAL_CHANGED_LEADING_TEXT: `합계가 변경되었고 이제`,
    TOTAL_CHANGED_TRAILING_TEXT: `주문을 계속해서 하시겠습니까?`,
    TOTAL_PAID: `결제 완료 합계`,
    TOTAL_REMAINING: `남은 금액`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `다시 시도`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `손님의 위치를 찾을 수 없어보입니다.  주소를 입력해 주세요.`,
    UNAVAILABLE_ITEM: `죄송합니다. 이 상품은 현재 사용할 수 없습니다.`,
    UNIT_GRAM: `{{$1: amount}}g`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}} 칼로리`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}} 단백질`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}} 탄수화물`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}} 지방`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}} 당류`,
    UP_TO_X: `...{{$1: number}} 까지`,
    USE_COMP_CARD: `컴프 카드 사용`,
    USE_COUPON: `쿠폰 사용`,
    USE_EBT_CARD: `EBT 카드`,
    USE_EBT_CASH_BENEFIT: `EBT 현금 혜택`,
    USE_EBT_FOOD_STAMP: `EBT 푸드 스탬프`,
    USE_GIFT_CARD: `상품권 사용`,
    USERNAME: `사용자 이름`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `이메일이 올바르지 않습니다.`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `{{$1: field name, e.g. 'email'}} 이 필요합니다`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `이 항목은 필수입니다`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `문자와 숫자만 사용하세요`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `문자와 숫자, &, #, 또는 . 만 사용하세요`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `비밀번호는 14자리 이상으로 최소한 숫자 1, 대문자 1, 소문자 1가 포함되어야 합니다.`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `우편번호가 맞지 않습니다.`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `우편번호는 숫자여야 합니다`,
    VENDOR_UNAVAILABLE_MESSAGE: `이 상점은 현재 영업이 종료되었습니다. 영업시간을 확인하고 다른 시간에 다시 방문해 주세요.`,
    VEHICLE_COLOR: `차량 색상`,
    VEHICLE_MAKE: `차량 제조사`,
    VEHICLE_MODEL: `차량 모델`,
    VERIFY_ACCOUNT: `계정 확인`,
    VERIFY_ACCOUNT_CTA: `주문을 시작하려면 계정을 확인하세요.`,
    VIDEO_LOAD_FAILED: `동영상을 불러오지 못했습니다`,
    VIEW: `보기`,
    WE_APOLOGIZE: `불편을 드려 죄송합니다.`,
    WEIGHING_INSTRUCTIONS: `상품을 저울 위에 올려 주세요`,
    WELCOME_BACK: `다시 오셨군요! 회원님을 위한 추천 상품:`,
    WELCOME_BACK_WITH_NAME: `다시 오셨군요, {{$1: guest name}} 님! 회원님을 위한 추천 상품:`,
    WELCOME_TO: `{{$1: org name}}에 오신 것을 환영합니다!`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `픽업 시간 선택`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `어디서 받으시겠습니까?`,
    YES: `예`,
    YOU_PREVIOUSLY_ORDERED: `이전에 주문하신 항목`,
    YOUR_CURRENT_LOCATION: `손님의 현재 장소`,
    YOUR_NAME: `성함`,
    YOUR_ORDER: `주문`,
    YOUR_SUBTOTAL: `소계`,
    ZOOM_TOGGLE_ON: `탭하여 핀치 줌 활성화`,
    ZOOM_TOGGLE_OFF: `탭하여 핀치 줌 비활성화`,
    ZOOM_INSTRUCTIONS: `핀치 줌이 활성화되었습니다. 두 손가락으로 확대 및 축소하세요.`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `자세히 알아보기`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `내 위치는?`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `현재 위치`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `장소 찾기`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `손가락으로 드래그하여 공간을 둘러보세요.`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `강조된 장소를 탭하여 자세히 알아보세요.`,
    'cover.session.timeout': `문제가 발생했습니다. 다시 시도해 주세요.`,
    'cover.reduced-height.button': `주문 시작`,
    'cover.loyalty.title': `환영합니다`,
    'cover.five-guys.documents': ``,
    'cover.five-guys.allergen-nutrition': ``,
    'cover.five-guys.ingredients': ``,
    'cover.five-guys.storm-document-instructions': ``,
    'cover.loyalty.login': `멤버십으로 로그인`,
    'cover.loyalty.guest': `게스트로 계속`,
    'guest-identifier.button.quit': `종료`,
    'guest-identifier.button.skip': `건너뛰기`,
    'guest-identifier.button.back': `뒤로`,
    'guest-identifier.button.next': `계속`,
    'guest-identifier.button.submit.cover': `계속`,
    'guest-identifier.button.submit.edit': `계속`,
    'guest-identifier.button.submit.checkout': `계속`,
    'guest-identifier.phone.tos.button-back': `뒤로`,
    'guest-identifier.phone.tos.title': `서비스 약관`,
    'guest-identifier.phone.tos.link': `전화번호 서비스 약관`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `멤버십 계정으로 로그인`,
    'guest-identifier.name.loyalty-button': `멤버십으로 로그인`,
    'guest-identifier.name.loyalty-separator': `또는`,
    'guest-identifier.name.loyalty-error-title': `이런! 이름을 찾을 수 없음`,
    'guest-identifier.name.loyalty-error-description': `죄송합니다. 이 계정과 연결된 이름을 찾을 수 없습니다. 아래에 이름을 입력해 주세요`,
    'inactivity-timer.button.continue': `네, 시간이 더 필요합니다`,
    'inactivity-timer.button.exit': `아니요, 완료했습니다`,
    'item-card.add.with-quantity': `추가 ({{$1: quantity}})`,
    'image.scan.default.alt': `바코드 또는 QR 코드를 스캔하세요`,
    'loyalty.view_coupons': `쿠폰 보기`,
    'loyalty.add_coupons': `쿠폰 추가`,
    'loyalty.label.manual_redemption': `교환 코드`,
    'loyalty.label.manual_redemption_instructions': `리워드를 교환하려면 교환 코드를 입력하세요`,
    'loyalty.label.welcome.new-user': `안녕하세요, {{$1: user}} 님! 멤버십 계정이 생성되었습니다`,
    'loyalty.reward_label.payment_unapplied': `등록된 카드에 결제 적용`,
    'loyalty.reward_label.redeemable_unredeemed': `{{$1: points}} 포인트로 교환`,
    'loyalty.reward_label.payment_at_checkout': `결제 시 적용 가능`,
    'loyalty.reward_group_label.payment': `결제 리워드`,
    'loyalty.rewards.payment-reward.name': `잔액으로 결제`,
    'loyalty.rewards.payment-reward.name-with-amount': `잔액으로 결제 ({{$1: amount}})`,
    'loyalty.rewards.payment-reward.description': `현재 잔액`,
    'loyalty.rewards.card-on-file-payment.description': `등록된 카드로 결제가 청구됩니다.`,
    'loyalty.redemption_auth.back_to_rewards': `리워드로 돌아가기`,
    'loyalty.redemption_auth.subtitle': `교환 바코드를 스캔하여 리워드를 교환하세요`,
    'loyalty.redemption_auth.submit': `리워드 교환`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': ``,
    'loyalty.signup.email-and-sms-consent': ``,
    'loyalty.signup.enter-your-email-address': ``,
    'loyalty.signup.enter-your-name': `이름 입력`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `계속하려면 이용 약관에 동의해 주세요.`,
    'loyalty.checkout-signup.header': `이 주문에서 리워드를 적립할 마지막 기회입니다!`,
    'loyalty.checkout-signup.skip': `건너뛰고 결제로 이동`,
    'loyalty.checkout-signup.success.new-account.title': `새 계정이 생성되었습니다`,
    'loyalty.checkout-signup.success.new-account.description': `가입해 주셔서 감사합니다. 이 주문에서 리워드를 적립하실 수 있습니다!`,
    'loyalty.checkout-signup.success.existing-account.title': `계정이 이미 존재합니다`,
    'loyalty.checkout-signup.success.existing-account.description': `이 번호로 이전에 등록하셨습니다. 지금 로그인되었습니다.`,
    'loyalty.checkout-signup.error.title': `계정 생성 오류`,
    'loyalty.checkout-signup.error.description': `계정 생성 중 문제가 발생했습니다`,
    'loyalty.checkout-signup.error.skip': `건너뛰고 결제로 이동`,
    'loyalty.checkout-signup.error.try-again': `다시 시도`,
    'menu.item.reset': `상품 초기화`,
    'menu.mod-group.quick-select': `빠른 선택`,
    'menu.mod-group.quick-select-active': `선택됨`,
    'menu.mod-group.quick-select-clear': ``,
    'menu.page.scanner.initial.title': `상품을 스캔하여 주문을 시작하세요`,
    'menu.page.scanner.scanned.title': `장바구니 상품`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `스캔한 상품 보기`,
    'order-history.button.add-to-order': `사용 가능한 상품 추가 ({{$1: number}})`,
    'order-history.title': `주문 내역`,
    'order-history.subtitle': `이전 주문이 모두 여기에 표시됩니다. 상품을 눌러 확인하거나 현재 주문에 추가하세요. 한 번의 탭으로 주문의 모든 상품을 추가할 수 있습니다.`,
    'order-history.next-page': `다음`,
    'order-history.previous-page': `이전`,
    'order-history.screen.close': `닫기`,
    'order-history.screen.error.title': `문제가 발생했습니다`,
    'order-history.screen.error.subtitle': `주문 내역을 불러오는 데 실패했습니다. 나중에 다시 시도해 주세요.`,
    'order-history.screen.error.button.back': `뒤로`,
    'order-history.screen.error.button.retry': `다시 시도`,
    'order-history.screen.no-orders': `이전 주문을 찾을 수 없습니다. 주문 후 여기에서 확인하세요.`,
    'order-history.screen.order-has-quick-add-uneligible-items': `이 주문의 일부 상품은 빠른 재주문이 불가능합니다. 상품을 개별적으로 탭하여 추가해 주세요.`,
    'order-history.section.button.view-all': `내 주문 더 보기`,
    'order-history.topbar.button.back': `뒤로`,
    'loyalty.unapplicable_rewards_warning_title': `적용 불가 리워드`,
    'loyalty.unapplicable_rewards_warning_description': `선택한 리워드를 교환하려면 해당 상품을 장바구니에 추가해 주세요. 리워드와 할인은 결제 시 적용됩니다.`,
    'loyalty.unapplicable_rewards_warning_confirm': `적용`,
    'loyalty.discard_reward_changes.title': ``,
    'loyalty.discard_reward_changes.description': ``,
    'loyalty.discard_reward_changes.keep_editing': ``,
    'loyalty.discard_reward_changes.discard': ``,
    'loyalty.rewards.terms_button_label': ``,
    'loyalty.rewards.terms_dialog.apply': ``,
    'loyalty.rewards.terms_dialog.remove': ``,
    'loyalty.rewards.terms_dialog.back': ``,
    'loyalty.reward_ineligible.title': ``,
    'loyalty.reward_ineligible.title_generic': ``,
    'loyalty.reward_ineligible.title_plural': ``,
    'loyalty.reward_ineligible.description': ``,
    'loyalty.reward_ineligible.description_plural': ``,
    'loyalty.reward_ineligible.back_to_menu': ``,
    'loyalty.reward_ineligible.continue': ``,
    'loyalty.reward_ineligible.continue_plural': ``,
    'loyalty.auth_method.manual_redemption': `수동 입력`,
    'loyalty.button.menu.authed': `리워드`,
    'loyalty.button.menu.unauthed': `리워드`,
    'loyalty.button.checkout.authed': `리워드`,
    'loyalty.button.checkout.unauthed': `리워드`,
    'loyalty.error.reward_failed_to_apply': `리워드 적용에 실패했습니다. 다시 시도해 주세요.`,
    'loyalty.login.pin.label': ``,
    'loyalty.login.pin.error-required': ``,
    'loyalty.login-options.button.skip.menu': `건너뛰고 메뉴로 이동`,
    'loyalty.login-options.button.skip.checkout': `건너뛰고 결제로 이동`,
    'loyalty.login-options.button.skip.dining-option-collection': `건너뛰고 결제 계속`,
    'loyalty.login-options.title': `로그인 방법 선택 또는 게스트로 계속`,
    'loyalty.login-options.subtitle': `나중에 언제든지 로그인할 수 있습니다`,
    'loyalty.login-options.signup.link': `계정이 없으신가요? 가입하세요`,
    'loyalty.login-options.barcode.title': `바코드 스캔`,
    'loyalty.login-options.barcode.subtitle': `바코드를 스캔하여 로그인`,
    'loyalty.login-options.email-phone-number.title': `이메일 및 전화번호`,
    'loyalty.login-options.email-phone-number.subtitle': `로그인하려면 이메일과 전화번호를 입력하세요`,
    'loyalty.login-options.email-password.title': `이메일 및 비밀번호`,
    'loyalty.login-options.email-password.subtitle': `로그인하려면 이메일과 비밀번호를 입력하세요`,
    'loyalty.login-options.username-password.title': `사용자 이름 및 비밀번호`,
    'loyalty.login-options.username-password.subtitle': `로그인하려면 사용자 이름과 비밀번호를 입력하세요`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `전화번호`,
    'loyalty.login-options.phone-number.subtitle': `로그인하려면 전화번호를 입력하세요`,
    'loyalty.login-options.card-number.title': `카드 번호`,
    'loyalty.login-options.card-number.subtitle': `로그인하려면 카드 번호를 입력하세요`,
    'loyalty.login-options.email.title': `이메일`,
    'loyalty.login-options.email.subtitle': `로그인하려면 이메일을 입력하세요`,
    'loyalty.login-options.or': `또는`,
    'loyalty.login-options.popup.close': `닫기`,
    'loyalty.error.or': `또는`,
    'loyalty.login-error.saved-form': `제출하신 정보:`,
    'loyalty.login-error.try-again.button': `다시 시도`,
    'loyalty.otp.enter-code.title': `전송된 코드를 입력하세요`,
    'loyalty.otp.sent-to.email': `{{$1: masked email}}(으)로 코드를 이메일로 보냈습니다`,
    'loyalty.otp.sent-to.sms': `{{$1: masked phone number}}(으)로 코드를 문자로 보냈습니다`,
    'loyalty.otp.verify': `확인`,
    'loyalty.otp.resend': `코드 재전송`,
    'loyalty.otp.code.error.invalid': `코드가 올바르지 않습니다. 다시 시도해 주세요.`,
    'loyalty.otp.send-error.message': `해당 정보와 정확히 일치하는 계정을 찾을 수 없습니다. 확인 후 다시 시도해 주세요.`,
    'loyalty.login.fallback.phone-number.button': `전화번호 사용`,
    'loyalty.login.fallback.barcode.button': `바코드 또는 QR 코드 스캔`,
    'loyalty.login.fallback.card-number.button': `카드 번호 사용`,
    'loyalty.login.fallback.email.button': `이메일 사용`,
    'loyalty.login.fallback.email-phone-number.button': `이메일 및 전화번호 사용`,
    'loyalty.login.fallback.email-password.button': `이메일 및 비밀번호 사용`,
    'loyalty.login.fallback.username-password.button': `사용자 이름 및 비밀번호 사용`,
    'loyalty.login.auth-method.phone-number.title': `전화번호`,
    'loyalty.login.auth-method.barcode.title': `바코드 또는 QR 코드 스캔`,
    'loyalty.login.auth-method.card-number.title': `카드 번호`,
    'loyalty.login.auth-method.email.title': `이메일`,
    'loyalty.login.auth-method.email-phone-number.title': `이메일 및 전화번호`,
    'loyalty.login.auth-method.email-password.title': `이메일 및 비밀번호`,
    'loyalty.login.auth-method.username-password.title': `사용자 이름 및 비밀번호`,
    'vitrine.error.order_validation_failed': `주문 확인에 실패했습니다. 다시 시도해 주세요.`,
    'vitrine.error.handshake_failed': `키오스크에 연결할 수 없습니다. 직원에게 문의해 주세요.`,
    'vitrine.error.request_timeout': `요청을 완료할 수 없습니다. 다시 시도해 주세요.`,
    'vitrine.error.request_aborted': `요청을 완료할 수 없습니다. 다시 시도해 주세요.`,
    'vitrine.error.analytics_send_error': `분석 데이터를 전송할 수 없습니다. 다시 시도해 주세요.`,
    'vitrine.error.garcon_incompatible_build': `키오스크에 연결할 수 없습니다. 도움이 필요하시면 직원에게 문의해 주세요.`,
    'vitrine.error.loyalty-login-no-matching-user-title': `계정을 찾을 수 없음`,
    'vitrine.error.loyalty-login-no-matching-user-message': `제공된 정보와 일치하는 사용자를 찾을 수 없습니다.`,
    'vitrine.error.loyalty_not_enough_points': `선택한 리워드를 교환하기에 포인트가 부족합니다.`,
    'vitrine.error.order_total_above_max': `주문 합계가 허용되는 최대값을 초과했습니다. 직원에게 문의해 주세요.`,
    'vitrine.error.empty_menu': `선택한 메뉴가 현재 비어 있습니다. 다른 식사 옵션을 시도해 주세요.`,
    'maitred.error.integration_bad_config': `키오스크 구성에 문제가 있는 것 같습니다. 직원에게 문의해 주세요.`,
    'checkout.done.expo_receipt.error': `영수증을 인쇄할 수 없습니다. 다시 시도해 주세요.`,
    'checkout.done.expo_receipt.success': `영수증이 전송되었습니다! 팀원에게 도움을 요청해 주세요.`,
    'checkout.done.print-receipt.out-of-paper': `프린터에 용지가 없습니다. 영수증을 받으시려면 팀원에게 문의해 주세요.`,
    'refunder.viewing-results.button.cancel': `취소`,
    'refunder.viewing-results.button.refund-all': `모두 환불`,
    'refunder.viewing-results.button.view-transaction': `거래 보기`,
    'refunder.viewing-results.button.done': `완료`,
    'refunder.viewing-results.button.back': `뒤로`,
    'refunder.viewing-results.button.search': `주문 검색`,
    'refunder.viewing-results.refund-order.error-print-receipt': `주문이 성공적으로 환불되었지만 영수증을 인쇄할 수 없습니다. 다시 인쇄해 주세요.`,
    'refunder.viewing-results.refund-order.success': `주문이 성공적으로 환불되었습니다.`,
    'refunder.viewing-results.refund-order.error': `주문 환불에 실패했습니다. 다시 시도해 주세요.`,
    'refunder.viewing-results.order.refunded': `주문 환불됨`,
    'refunder.viewing-results.order.total': `주문 합계`,
    'refunder.search-form.button.back': `뒤로`,
    'refunder.search-form.button.search': `검색`,
    'refunder.viewing-order.title': `주문 #{{$1: order number}}의 모든 거래`,
    'refunder.viewing-order.subtitle': `환불할 거래를 선택해 주세요.`,
    'refunder.viewing-order.button.cancel': `취소`,
    'refunder.viewing-order.button.refund': `환불`,
    'refunder.viewing-order.button.refund-partial': `부분 환불`,
    'refunder.viewing-order.button.retry': `다시 시도`,
    'refunder.viewing-order.button.done': `완료`,
    'refunder.viewing-order.button.back': `뒤로`,
    'refunder.viewing-order.refund-transaction.error': `거래 환불에 실패했습니다. 다시 시도해 주세요.`,
    'refunder.viewing-order.refund-transaction.success': `거래가 성공적으로 환불되었습니다.`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `거래가 성공적으로 환불되었지만 영수증을 인쇄할 수 없습니다. 다시 인쇄해 주세요.`,
    'refunder.viewing-order.transaction.total': `합계`,
    'refunder.viewing-order.transaction.refunded': `환불됨`,
    'refunder.viewing-order.error.title': `오류`,
    'refunder.viewing-order.error.message': `주문을 불러오는 데 실패했습니다. 다시 시도해 주세요.`,
    'refunder.viewing-order.error.button.retry': `다시 시도`,
    'refunder.viewing-order.error.button.back': `뒤로`,
    'refunder.partial-transaction-refund.error.amount-too-high': `금액이 너무 높습니다.`,
    'refunder.partial-transaction-refund.error.amount-too-low': `금액이 너무 낮습니다.`,
    'refunder.partial-transaction-refund.error.amount-invalid': `금액이 유효하지 않습니다.`,
    'refunder.partial-transaction-refund.error.amount-required': `금액을 입력해야 합니다.`,
    'refunder.partial-transaction-refund.error': `환불 처리 중 문제가 발생했습니다. 다시 시도해 주세요.`,
    'refunder.partial-transaction-refund.button.submit': `부분 환불 제출`,
    'refunder.partial-transaction-refund.button.back': `뒤로`,
    'refunder.partial-transaction-refund.title': `부분 거래 환불`,
    'refunder.partial-transaction-refund.hint': `환불하려는 금액을 입력해 주세요. 최대 금액은 {{$1: amount}}입니다`,
    'refunder.partial-transaction-refund.label': `금액`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.alcohol-requires-food.notice': ``,
    'checkout.cart.alcohol-requires-food.title': ``,
    'checkout.cart.alcohol-requires-food.description': ``,
    'checkout.cart.group-ordering.actions.change-recipient': `수령인 편집`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `상품을 할당할 사람`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `취소`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `새로 추가`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `재할당`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `이 상품은 누구 것인가요?`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `이 게스트에게 할당`,
    'checkout.cart.starbucks-stars': `{{$1: amount}} ★ 상품`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'checkout.cart.upsize.title': ``,
    'checkout.cart.upsize.label': ``,
    'menu.nav.starbucks.menu': `메인 메뉴`,
    'menu.nav.starbucks.wayfinder': `안내 지도`,
    'menu.disclaimer.title': ``,
    'menu.disclaimer.more': ``,
    'menu.secret-menu.access-code.title': `접근 코드 입력`,
    'menu.secret-menu.access-code.button.back': `뒤로`,
    'menu.secret-menu.access-code.button.submit': `제출`,
    'menu.secret-menu.access-code.error': `유효하지 않은 접근 코드`,
    'menu.secret-menu.access-code.success': `접근 코드가 승인되었습니다`,
    'menu.toast.added-to-cart': `장바구니에 추가됨`,
    'menu.toast.combo-savings': `세트 할인!`,
    'menu.toast.discount-applied': `할인 적용됨!`,
    'menu.mod-group-upsell.title': ``,
    'menu.mod-group-upsell.body': ``,
    'menu.mod-group-upsell.decline': ``,
    'menu.mod-group-upsell.confirmation.title': ``,
    'menu.mod-group-upsell.confirmation.body': ``,
    'menu.exit-verification.title': `관리자 확인 필요`,
    'menu.exit-verification.description': `종료하려면 직원 접근 코드가 필요합니다. 팀원에게 도움을 요청해 주세요.`,
    'menu-item.starbucks-stars': `{{$1: amount}} ★`,
    'menu-item.product-information.title': ``,
    'menu-item.product-information.open': ``,
    'menu-item.product-information.tab.product-info': ``,
    'menu-item.product-information.tab.nutrition': ``,
    'menu-item.product-information.tab.allergens': ``,
    'menu-item.product-information.nutrition.option': ``,
    'menu-item.product-information.empty': ``,
    'menu-item.scale.title': `상품을 저울 위에 올려 주세요.`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `무게`,
    'menu-item.scale.price-per-unit': `{{$2: unit}}당 {{$1: price}}`,
    'menu-item.scale.price': `가격`,
    'menu-item.scale.instructions': `저울을 사용하여 상품의 무게를 재세요. 초기화하려면 저울의 표시된 버튼을 누르세요.`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `무게 측정 중...`,
    'menu-item.scale.error-reading-weight': `무게를 읽는 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    'menu-item.scale.error-no-weight': `주문에 추가하려면 상품의 무게를 재주세요.`,
    'menu-item.scale.no-scale': `저울이 감지되지 않습니다. 직원에게 문의해 주세요.`,
    'also-consider.title': `이런 건 어떠세요...`,
    'also-consider.back-to-item': `상품으로 돌아가기`,
    'also-consider.add-to-order': `주문에 추가`,
    'also-consider.skip-add-on': `추가 항목 건너뛰기`,
    'menu-item.assorted.title': `나만의 구성 만들기`,
    'menu-item.assorted.count': `{{$2: total}}개 중 {{$1: count}}개 선택됨`,
    'menu-item.row-size-mod.option.none': `없음`,
    'menu-item.upsize.prompt.title': `더 큰 사이즈로 하시겠어요?`,
    'menu-item.upsize.comparison.title': ``,
    'menu-item.upsize.comparison.accept': ``,
    'menu-item.upsize.comparison.speech': ``,
    'menu-item.upsize.comparison.price-difference': ``,
    'menu-item.upsize.prompt.accept': `네, {{$1: size name}}(으)로 변경`,
    'menu-item.upsize.prompt.decline': `아니요, 괜찮아요`,
    'menu-item.upsize.nudge': `{{$1: size name}}(으)로 변경`,
    'menu-item.upsize.selection-loss.title': ``,
    'menu-item.upsize.selection-loss.description': ``,
    'menu-item.upsize.selection-loss.confirm': ``,
    'menu-item.upsize.selection-loss.cancel': ``,
    'menu-item.high-sugar-warning.description': `경고: 이 아이콘은 이 상품의 첨가당 함량이 2,000칼로리 식단 기준 첨가당 하루 권장 총 한도(50g) 이상임을 나타냅니다. 첨가당을 장기간 다량 섭취하면 제2형 당뇨병, 체중 증가 및 충치의 위험이 높아질 수 있습니다.`,
    'menu-item.high-sodium-warning.description': `경고: 이 아이콘은 이 상품의 나트륨(소금) 함량이 하루 권장 총 한도(2,300mg)보다 높음을 나타냅니다. 나트륨을 다량 섭취하면 혈압이 상승하고 심장병 및 뇌졸중의 위험이 높아질 수 있습니다.`,
    'menu-item.group-ordering.items-for': `단체 주문 - 상품 수령인:`,
    'menu-item.group-ordering.prompt.title': `단체로 주문하시겠습니까?`,
    'menu-item.group-ordering.prompt.description': `단체 주문 옵션은 각 상품이 그룹 내 어느 구성원의 것인지 확인합니다. 단체 주문을 활성화하려면 "예"를 누르세요. 이 옵션으로 계속하려면 "아니요"를 누르세요.`,
    'menu-item.group-ordering.prompt.button.accept': `네, 단체 주문`,
    'menu-item.group-ordering.prompt.button.decline': `아니요, 괜찮습니다`,
    'menu-item.group-ordering.add-recipient': `새로 추가`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `새 수령인 추가`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `수령인 이름을 입력하세요`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `게스트에게 할당`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `취소`,
    'menu-item.group-ordering.recipient-picker.title': `누구 것인가요?`,
    'menu-item.group-ordering.recipient-picker.add-new': `새로 추가`,
    'menu-item.nested-mod-groups.edit': `편집`,
    'menu-item.nested-mod-groups.popup.done': `완료`,
    'menu-item.nested-mod-groups.popup.cancel': `취소`,
    'menu-item.nested-mod-groups.popup.back': `뒤로`,
    'menu-item.nested-mod-groups.popup.next': `다음`,
    'checkout.cart.remove-item-verification.title': `관리자 확인 필요`,
    'checkout.cart.remove-item-verification.description': `장바구니에서 이 상품을 삭제하려면 직원 접근 코드가 필요합니다. 팀원에게 도움을 요청해 주세요.`,
    'checkout.cart.confirm-remove-item.title': `상품을 삭제하시겠습니까?`,
    'checkout.cart.confirm-remove-item.description': `{{$1: item name}}을(를) 장바구니에서 삭제하시겠습니까?`,
    'checkout.cart.confirm-remove-item.cancel': `취소`,
    'checkout.cart.confirm-remove-item.confirm': `삭제`,
    'checkout.cart.pre-checkout-recommendations.title': `주문 완성하기`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `계속`,
    'checkout.cart.pre-checkout-recommendations.back-button': `뒤로`,
    'checkout.cart.item-86d.title.items': `일부 상품을 더 이상 이용할 수 없습니다`,
    'checkout.cart.item-86d.title.mods': `일부 옵션을 더 이상 이용할 수 없습니다`,
    'checkout.cart.item-86d.title.mixed': `일부 상품과 옵션을 더 이상 이용할 수 없습니다`,
    'checkout.cart.item-86d.description.items': `다음 상품이 장바구니에서 삭제되었습니다:`,
    'checkout.cart.item-86d.description.mods': `다음 옵션이 상품에서 삭제되었습니다:`,
    'checkout.cart.item-86d.description.mixed': `다음 항목을 더 이상 이용할 수 없어 삭제되었습니다:`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}} ({{$2: item name}}에 포함)`,
    'checkout.cart.item-86d.edit-item-button': `편집`,
    'checkout.payment-options.tip.invalid-tip-amount': `죄송합니다. 주문 합계보다 큰 팁을 적용할 수 없습니다. 주문 소계에서 할인을 뺀 금액보다 작은 팁 금액을 입력해 주세요.`,
    'checkout.payment-options.name.title': `안녕하세요, {{$1: name}} 님`,
    'checkout.payment-options.gift-cards.prompt.title': `상품권 결제 방법을 선택하세요`,
    'checkout.payment-options.gift-cards.prompt.default-option': `상품권`,
    'checkout.payment-options.pay-with-cash-machine.label': `탭하여 현금 결제기로 결제`,
    'checkout.payment-options.pay-with-cash-machine.button': `현금`,
    'checkout.payment-options.donation.or': `또는`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `서비스 요금 정보`,
    'checkout.payment-options.credit-card.button.zero-balance': `주문하기`,
    'checkout.payment-options.inline-loyalty.view-all': `모든 리워드 보기`,
    'checkout.payment-options.inline-loyalty.apply': `리워드 적용`,
    'checkout.payment-options.inline-loyalty.greeting': `안녕하세요, {{$1: name}} 님!`,
    'checkout.payment-options.inline-loyalty.star-balance': `별 잔액: {{$1: stars}}★`,
    'checkout.payment-options.inline-loyalty.celebration.title': `생일 축하합니다!`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `생일 축하합니다, {{$1: name}} 님!`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `선물을 즐기세요!`,
    'checkout.payment-options.inline-loyalty.error.title': `리워드를 적용할 수 없습니다`,
    'checkout.payment-options.inline-loyalty.error.message': `리워드 적용 중 오류가 발생했습니다. 다시 시도해 주세요.`,
    'loyalty.starbucks.header.redeemable-stars': `교환 가능한 별`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}★ {{$2: date}} 만료`,
    'loyalty.starbucks.header.stars-no-expiry': `별이 만료되지 않습니다`,
    'loyalty.starbucks.progress.next-status-by-date': `{{$2: date}}까지 {{$1: stars}}★을 적립하여 {{$3: level}} 등급에 도달하세요`,
    'loyalty.starbucks.progress.next-status': `{{$1: stars}}★을 적립하여 {{$2: level}} 등급에 도달하세요`,
    'loyalty.starbucks.progress.maintain-status-by-date': `{{$2: date}}까지 {{$1: stars}}★을 적립하여 {{$3: level}} 등급을 1년 더 연장하세요`,
    'loyalty.starbucks.progress.maintain-status': `{{$1: stars}}★을 적립하여 {{$2: level}} 등급을 1년 더 연장하세요`,
    'loyalty.starbucks.progress.extended': `1년 더 연장됨`,
    'loyalty.starbucks.progress.annual-earned': `연간 적립`,
    'loyalty.starbucks.progress.status-target': `{{$1: level}} 등급`,
    'loyalty.starbucks.progress.to-extend': `연장하려면`,
    'loyalty.starbucks.birthday.title': `생일 축하합니다, {{$1: name}} 님!`,
    'loyalty.starbucks.birthday.title-no-name': `생일 축하합니다!`,
    'loyalty.starbucks.birthday.redeem': `생일 쿠폰을 교환하세요!`,
    'loyalty.starbucks.birthday.description': `저희가 준비한 좋아하는 음료나 간식을 즐기세요. 결제 시 교환하거나 주문할 때 바리스타에게 알려주세요.`,
    'loyalty.starbucks.birthday.valid-until': `{{$1: date}}까지 유효`,
    'loyalty.starbucks.member-since': `{{$1: year}}년부터 회원`,
    'loyalty.starbucks.member-since.subtitle': `충성스러운 스타벅스 리워드 회원이 되어 주셔서 감사합니다.`,
    'checkout.paying.error.card-not-accepted': ``,
    'checkout.paying.error.loyalty-payment': `죄송합니다. 결제를 처리할 수 없습니다. 다시 시도해 주세요.`,
    'checkout.paying.error.pos.print': `계속하고 영수증 인쇄`,
    'checkout.paying.error.table-tracker.print': `계속하고 영수증 인쇄`,
    'checkout.paying.error.table-tracker.title': `이런! 호출기를 받을 수 없습니다.`,
    'checkout.paying.error.table-tracker.instructions': `주문은 완료되었으나 주문 추적을 위한 테이블 트래커 배출 중 오류가 발생했습니다. 다음 단계로 진행하여 영수증을 받으세요.`,
    'checkout.paying.error.title': `이런!`,
    'checkout.paying.sending-table-tracker-request.title': `호출기 배출 중`,
    'checkout.paying.sending-table-tracker-request.subtitle': `테이블 트래커를 배출하는 동안 잠시 기다려 주세요.`,
    'checkout.paying.cash-machine.pinging.title': `현금 결제기 확인 중`,
    'checkout.paying.cash-machine.pinging.subtitle': `현금 결제기를 사용할 수 있는지 확인하는 동안 잠시 기다려 주세요.`,
    'checkout.paying.cash-machine.awaiting.title': `현금 결제기 사용 중`,
    'checkout.paying.cash-machine.awaiting.subtitle': `현금 결제기를 사용할 수 있을 때까지 기다려 주세요.`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `취소`,
    'checkout.paying.cash-machine.receiving.title': `현금 결제기 준비됨`,
    'checkout.paying.cash-machine.receiving.subtitle': `현금 결제기에 결제 금액을 투입해 주세요.`,
    'checkout.paying.cash-machine.receiving.cancel-button': `취소`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `취소 및 결제 환불`,
    'checkout.paying.cash-machine.receiving.partial-button': `나머지를 다른 방법으로 결제`,
    'checkout.paying.cash-machine.receiving.amount': `{{$1: amount}} 남음`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `현금 결제기에서 모든 지폐와 동전을 가져가 주세요.`,
    'checkout.paying.cash-machine.cancelling.title': `현금 결제기 결제 취소 중`,
    'checkout.paying.cash-machine.cancelling.subtitle': `현금 결제기에서 모든 지폐와 동전을 가져가 주세요.`,
    'checkout.paying.cash-machine.cancelling.error.title': `현금 결제기 결제 취소 오류`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `결제를 취소할 수 없습니다. 직원에게 도움을 요청해 주세요.`,
    'checkout.paying.cash-machine.cancelling.error.print': `계속하고 영수증 인쇄`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `거스름돈 부족`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `현금 결제기가 거스름돈을 드릴 수 없어 결제를 환불해 드렸습니다.`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `다시 시도`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `뒤로`,
    'checkout.paying.cash-machine.error.message': `현금 결제기가 결제를 처리할 수 없습니다. 다시 시도해 주세요.`,
    'checkout.done.details.guest-name': `이름`,
    'checkout.done.details.table-number': `테이블 번호`,
    'checkout.done.details.tracker-number': `추적 번호`,
    'checkout.done.details.order-number': `주문 번호`,
    'checkout.done.error.table-tracker.instructions': `호출기를 받는 중 오류가 발생했습니다. 주문은 성공적으로 처리되었습니다. 직원에게 도움을 요청해 주세요.`,
    'checkout.done.qr-code.error': `죄송합니다. 영수증용 QR 코드를 생성할 수 없습니다.`,
    'printer-receipt.stored-value-remaining-balance': `{{$1: label}} 잔액`,
    'printer-receipt.order-ready-at': ``,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': ``,
    'order-reconciler.error.dining-option-unavailable': `선택하신 식사 옵션을 더 이상 이용할 수 없습니다. 주문이 "{{$1: dining option name}}"을(를) 사용하도록 업데이트되었습니다.`,
    'order-reconciler.error.items-unavailable': `주문의 일부 상품을 더 이상 이용할 수 없습니다. 이용할 수 없는 상품을 제거하도록 주문이 업데이트되었습니다. 다음 상품이 삭제되었습니다: {{$1: item names}}`,
    'page-nav.order-history-item.title': `내 주문`,
    'page-nav.order-history-item.cta': `내 주문 보기`,
    'print.error.phone-number-label': `전화번호`,
    'print.error.guest-name-label': `이름`,
    'print.error.table-number-label': `테이블 번호`,
    'print.error.tracker-number-label': `추적 번호`,
    'print.error.order-number-label': `주문 번호`,
    'debug.untranslated-locale': ``,
};
//# sourceMappingURL=strings.ko-kr.js.map